import React, { useRef, useState, useCallback, useEffect } from 'react';

// Usando componentes Shadcn/Tailwind

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "src/@/components/ui/dialog";
import { Card } from 'src/@/components/ui/card';
import { Popover, PopoverContent, PopoverTrigger } from 'src/@/components/ui/popover';
import { Button } from 'src/@/components/ui/button';
import { Textarea } from 'src/@/components/ui/textarea';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/@/components/ui/tooltip';
import { Progress } from 'src/@/components/ui/progress';
import { Loader2 } from 'lucide-react';

import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
//hooks
import useResponsive from 'src/hooks/useResponsive';
//redux 
import {
	getChatsAtendimento,
	getChatsPendente,
	setDialogRespostas,
	setSelectedMessage,
	getCountsChats,
	setMensagensEnviar,
	resetMensagensEnviar,
	removeMensagemEnviarById,
	removeMensagensEnviarByChatId,
	updateChatList,
	updateChatInfoField,
	reorderChatsAtendimento,
	getChatInfoByChatId,
	sendGroupMessage
} from 'src/redux/slices/chat';
import { setIsOnlineUsers } from 'src/redux/slices/staff';
import { useDispatch, useSelector } from 'src/redux/store';
//services
import { getSession } from "src/services/auth";
//components
import ModalMensagensRapidas from "src/components/_chats/chat/components/ModalMensagensRapidas";
import ModalTemplatesWhatsApp from "src/components/_chats/chat/components/ModalTemplatesWhatsApp";
import ModalTemplatesMessenger from "src/components/_chats/chat/components/ModalTemplatesMessenger";
import v1_actionMessengerTemplates from "src/actions/v1/meta/messenger/v1_actionMessengerTemplates";
import ModalSearchProduct from "src/sections/@chats/chat/Modals/ModalSearchProduct";
import RecordingTimer from "src/components/_chats/chat/components/RecordingTimer";
import { UploadMultiFile } from 'src/components/upload';
import EmojiPicker from 'src/components/EmojiPicker';
import StickerPicker from 'src/components/StickerPicker';
import MediaPreviewOverlay from 'src/sections/@chats/chat/media-editor/MediaPreviewOverlay';
import { isEditorSupported } from 'src/sections/@chats/chat/media-editor/utils/mediaTypes';
import { verifyRules } from "src/utils/functions";
import { setModalAlerta } from "src/redux/slices/global";
///-----
import MicRecorder from "mic-recorder-to-mp3";
const recorder = new MicRecorder({ bitRate: 128 })
//zui
import { RowInput } from 'src/components/forms/RowInput';
//actions
import v1_actionEnviarArquivoBuffer from "src/actions/v1/whatsapp/v1_actionEnviarArquivoBuffer";
import v1_actionListarFigurinhas from "src/actions/v1/whatsapp/v1_actionListarFigurinhas";
import v1_actionCriarFigurinha from "src/actions/v1/whatsapp/v1_actionCriarFigurinha";
import v1_actionEnviarFigurinhaSalva from "src/actions/v1/whatsapp/v1_actionEnviarFigurinhaSalva";
import v1_actionDeletarFigurinha from "src/actions/v1/whatsapp/v1_actionDeletarFigurinha";
import v2_actionEnviarAudioBuffer from "src/actions/v2/whatsapp/v2_actionEnviarAudioBuffer";
import actionCriarNotas from 'src/actions/chats/notas/actionCriarNotas';
import v1_actionEnviarMenagemWhatsapp from "src/actions/v1/whatsapp/v1_actionEnviarMenagemWhatsapp";
import v1_actionEnviarVozWhatsapp from "src/actions/v1/whatsapp/v1_actionEnviarVozWhatsapp";
import v1_actionEnviarProduto from "src/actions/v1/whatsapp/v1_actionEnviarProduto";
import v1_actionResponderMensagemWhatsapp from "src/actions/v1/whatsapp/v1_actionResponderMensagemWhatsapp";
import actionListaRespostasRapida from "src/actions/dashboard/respostas-rapidas/actionListaRespostasRapida";
import actionSendFileMeta from 'src/actions/chats/meta/actionSendFileMeta';
import actionSendMessageMeta from 'src/actions/chats/meta/actionSendMessageMeta';
import { initCacheFileSave, saveMessageToIDB, storeImageBlob } from 'src/helpers/cache.helper';
import ChatComponent from 'src/components/_chats/chat/components/ChatPage/ChatComponent';
import WhatsAppCountdownTimer from 'src/components/_chats/chat/components/WhatsAppCountdownTimer';
import v2_actionAnaliseAtendimento from 'src/actions/v2/ai/v2_actionAnaliseAtendimento';

//utils
import { removeHttpPrefix } from 'src/utils/chats.utils';
import {
	isWhatsappBusiness,
	hasServiceWindowReference,
	isCtwaWindowGoverning,
	isServiceWindowExpired,
	getWindowExpiresAt,
	shouldBlockWhatsAppBusiness as shouldBlockWhatsAppBusinessWindow,
} from 'src/utils/serviceWindow.utils';
import { useToast } from 'src/@/components/ui/use-toast';
import { blobToBase64 } from 'src/helpers/audio.helper';
import * as Sentry from '@sentry/react';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "src/@/components/ui/dropdown-menu"
import Scrollbar from 'src/components/Scrollbar';
import axios from 'axios';
import { MessageSquareShare, Paperclip, Sparkles, Info, Mic, Send, X, Maximize2, Minimize2, Trash2, PenLine, NotebookPen, Package, Instagram, Clock, ArrowRight, MessageCircle, RefreshCw, Facebook, FileText } from 'lucide-react';
import v1_actionUrlToBuffer from 'src/actions/global/v1_actionUrlToBuffer';
import { partitionInstagramFiles, validateInstagramFile, getInstagramMediaKind, INSTAGRAM_ACCEPT } from 'src/utils/instagramMediaLimits';
import { fData } from 'src/utils/formatNumber';

const MultiFileDialog = ({
	open,
	onOpenChange,
	chat,
	cliente,
	isDocument,
	loadingEnviarArquivos,
	preview,
	files,
	onEnviarArquivosBuffer,
	handleDropMultiFile,
	handleRemove,
	handleRemoveAll,
	changeIsDocument,
}) => {
	const { t } = useTranslation();
	const [showLimitsInfo, setShowLimitsInfo] = useState(false);

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-2xl">
				<DialogHeader className="mt-4">
					<div className="flex items-center gap-4">
						<DialogTitle>{t('chat.upload.dialogTitle')}</DialogTitle>

						<Button
							onClick={() => setShowLimitsInfo(!showLimitsInfo)}
							className="h-6"
						>
							{t('chat.upload.fileLimit')}
							<Info width={18} height={18} />
						</Button>

					</div>
				</DialogHeader>
				<div className="flex flex-col items-center">
					{showLimitsInfo && (
						<div className="w-full mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
							<div className="flex items-start gap-2">
								<div className="text-blue-600 text-lg">📎</div>
								<div className="flex-1">
									<h4 className="font-semibold text-blue-800 text-sm mb-2">
										{t('chat.upload.limits.title')}
									</h4>
									<div className="space-y-1 text-xs text-blue-700">
										{chat?.canal === "whatsapp_business" ? (
											<>
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.imagesHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.videoHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.audioHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.documentsHtml', { size: '40 MB' }) }} />
											</>
										) : chat?.canal === "instagram" ? (
											<>
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.instagram.imageLimitHtml') }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.instagram.videoLimitHtml') }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.instagram.audioLimitHtml') }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.instagram.documentLimitHtml') }} />
											</>
										) : chat?.canal === "telegram" ? (
											// O Telegram busca o arquivo pela URL do S3: foto até 5 MB,
											// demais tipos até 20 MB (limite da Bot API por URL).
											<>
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.imagesHtml', { size: '5 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.videoHtml', { size: '20 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.audioHtml', { size: '20 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.documentsHtml', { size: '20 MB' }) }} />
											</>
										) : (
											<>
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.imagesHtml', { size: '5 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.videoHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.audioHtml', { size: '16 MB' }) }} />
												<div dangerouslySetInnerHTML={{ __html: t('chat.upload.limits.documentsHtml', { size: '40 MB' }) }} />
											</>
										)}
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="flex flex-col space-y-4">
						<div className="space-y-4">
							<UploadMultiFile
								canal={chat?.canal}
								isStaff={false}
								cliente={cliente}
								isDocument={isDocument}
								changeIsDocument={changeIsDocument}
								loadingEnviarArquivos={loadingEnviarArquivos}
								showPreview={preview}
								files={files || []}
								onEnviarArquivos={onEnviarArquivosBuffer}
								onDrop={handleDropMultiFile}
								onRemove={handleRemove}
								onRemoveAll={handleRemoveAll}
							/>
						</div>
					</div>
				</div>

			</DialogContent>
		</Dialog>
	);
};

// A rota /enviar-mensagem devolve um `codigo` estável para as falhas que o
// atendente consegue agir em cima; `mensagem` (pt-BR) fica como fallback quando
// o backend introduz um código novo. Antes o front só olhava `numberNotExists` e
// `statusConexao`, então qualquer outro 400 — inclusive TODOS os do WhatsApp
// Business, que nunca mandaram esses campos — falhava sem nenhum aviso na tela.
const SEND_ERROR_TRANSLATIONS = {
	NUMBER_NOT_EXISTS: 'chat.errors.numberNotExists',
	DISCONNECTED: 'chat.errors.channelDisconnected',
	SESSION_EXPIRED: 'chat.errors.sessionExpired',
	WINDOW_EXPIRED: 'chat.errors.windowExpired',
	RATE_LIMIT: 'chat.errors.rateLimit',
	// Falha sem causa conhecida: texto traduzido + `detalhe` do provedor, para o
	// atendente conseguir repassar algo concreto ao suporte.
	GENERIC: 'chat.errors.sendFailed',
};

// Códigos que merecem modal (bloqueiam o envio até o atendente resolver algo);
// o resto vira toast.
const SEND_ERROR_MODAL_CODES = ['NUMBER_NOT_EXISTS', 'DISCONNECTED'];

const resolveSendErrorCode = (error) => {
	const data = error?.response?.data;
	if (data?.codigo) return data.codigo;
	// Compatibilidade com o contrato antigo da rota.
	if (data?.numberNotExists) return 'NUMBER_NOT_EXISTS';
	if (data?.statusConexao === 'Disconnected') return 'DISCONNECTED';
	return null;
};

// "Enviar como documento" é uma preferência do atendente para aquele contato:
// fica gravada em localStorage e só muda quando ele mexe no switch — trocar de
// conversa, recarregar a página ou remontar a barra não desmarca mais.
const SEND_AS_DOCUMENT_STORAGE_PREFIX = 'chat_send_as_document:';

const getSendAsDocumentKey = (chat) => {
	const contato = chat?.numeroCliente || chat?._id;
	if (!contato) return null;
	return `${SEND_AS_DOCUMENT_STORAGE_PREFIX}${chat?.canal || 'default'}:${contato}`;
};

const readSendAsDocument = (chat) => {
	const key = getSendAsDocumentKey(chat);
	if (!key) return false;
	try {
		return localStorage.getItem(key) === 'true';
	} catch (error) {
		return false;
	}
};

const writeSendAsDocument = (chat, value) => {
	const key = getSendAsDocumentKey(chat);
	if (!key) return;
	try {
		localStorage.setItem(key, JSON.stringify(!!value));
	} catch (error) {
		// storage cheio/bloqueado: a preferência só não persiste entre sessões
	}
};

// Ondas animadas exibidas durante a gravação de áudio (puramente decorativas)
const RECORDING_WAVE_BARS = [0.35, 0.7, 1, 0.55, 0.85, 0.45, 0.95, 0.6, 0.8, 0.4, 0.9, 0.5, 0.75, 0.62, 1, 0.45, 0.85, 0.35, 0.65, 0.5];

const RecordingWave = () => (
	<div className="flex items-center gap-[3px] h-8 flex-1 min-w-0 justify-center overflow-hidden" aria-hidden="true">
		<style>{`
			@keyframes chat-rec-wave {
				0%, 100% { transform: scaleY(0.3); opacity: 0.55; }
				50% { transform: scaleY(1); opacity: 1; }
			}
		`}</style>
		{RECORDING_WAVE_BARS.map((h, i) => (
			<span
				key={i}
				className="w-[3px] rounded-full bg-red-400 flex-shrink-0"
				style={{
					height: `${Math.round(h * 28)}px`,
					animation: `chat-rec-wave 1.1s ease-in-out ${i * 0.085}s infinite`,
				}}
			/>
		))}
	</div>
);

// Barra de gravação (substitui o textarea enquanto grava): cancelar, dot pulsante +
// timer, ondas animadas e botão de enviar. `loading` = áudio sendo enviado.
const RecordingBar = ({ loading, onCancel, onSend, cancelLabel, sendLabel, sendingLabel }) => (
	<div className="flex-1 mt-2 flex items-center gap-2 sm:gap-3 h-[52px] px-2 sm:px-3 rounded-2xl border border-red-200 bg-red-50/70 animate-in fade-in slide-in-from-bottom-2 duration-300">
		<Button
			variant="ghost"
			size="icon"
			aria-label={cancelLabel}
			disabled={loading}
			onClick={onCancel}
			className="h-9 w-9 rounded-full text-red-400 hover:text-red-600 hover:bg-red-100 flex-shrink-0"
		>
			<Trash2 className="h-4 w-4" />
		</Button>

		<div className="flex items-center gap-1.5 flex-shrink-0 text-red-600 text-sm font-medium tabular-nums">
			<span className="relative flex h-2.5 w-2.5">
				<span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" />
				<span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" />
			</span>
			<RecordingTimer />
		</div>

		{loading ? (
			<div className="flex-1 flex items-center justify-center gap-2 text-red-400 text-xs">
				<Loader2 className="h-4 w-4 animate-spin" />
				<span className="hidden sm:inline">{sendingLabel}</span>
			</div>
		) : (
			<RecordingWave />
		)}

		<Button
			size="icon"
			aria-label={sendLabel}
			onClick={onSend}
			disabled={loading}
			className="h-9 w-9 rounded-full bg-[#7C3AED] hover:bg-[#6d28d9] text-white shadow-sm shadow-[#7C3AED]/25 active:scale-95 transition-all flex-shrink-0"
		>
			{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
		</Button>
	</div>
);

const NotesPopover = ({ open, setOpen, textNotes, setTextNotes, handleAddNote }) => {
	const { t } = useTranslation();
	return (
		<Popover onOpenChange={setOpen} open={open}>
			<PopoverTrigger asChild>
				<Button
					variant="secondary"
					onClick={() => setOpen(true)}
					className="h-8 px-3 rounded-full bg-violet-50 hover:bg-violet-100 border-violet-200 text-violet-700 text-xs font-medium flex-shrink-0 gap-1.5"
				>
					<NotebookPen className="h-3.5 w-3.5" />
					<span className="hidden sm:inline">{t('chat.notes.newShort')}</span>
				</Button>
			</PopoverTrigger>
			<PopoverContent className="w-80 min-h-[200px] rounded-xl">
				<div className='flex flex-col gap-5'>
					<div className="w-full flex flex-row justify-between items-center">
						<div className="flex items-center gap-2">
							<div className="w-8 h-8 rounded-lg bg-violet-50 flex items-center justify-center">
								<NotebookPen className="h-4 w-4 text-violet-600" />
							</div>
							<h4 className="font-medium leading-none text-sm">{t('chat.notes.createNew')}</h4>
						</div>
						<Button onClick={() => setOpen(false)} variant="ghost" size="icon" className="h-7 w-7 rounded-lg text-gray-400 hover:text-gray-700">
							<X className="h-4 w-4" />
						</Button>
					</div>
					<div className="mt-2">
						<RowInput
							label={t('chat.notes.label')}
							input={
								<Textarea
									value={textNotes}
									onChange={(e) => setTextNotes(e.target.value)}
									rows={4}
									multiline
								/>
							}
						/>
					</div>
					<Button onClick={handleAddNote} className="w-full bg-[#7C3AED] hover:bg-[#6d28d9] rounded-xl shadow-sm shadow-[#7C3AED]/20">
						{t('common:buttons.create')}
					</Button>
				</div>
			</PopoverContent>
		</Popover>
	);
};

const ChatBottomBar = ({ layoutMode, mediaOverlayRef, user, cliente, chat, mensagens, onOpenDrawerGpt, disabled, onCallbackResend, onCallbackAnalysis }) => {

	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { selectedMessage, dialogRespostasRapidas, chatInfo } = useSelector((state) => state.chat);
	const [loading, setLoading] = useState(false);
	const [text, setText] = useState("");
	const textareaRef = useRef(null);
	const [isExpanded, setIsExpanded] = useState(false);
	const [files, setFiles] = useState([]);
	const [multiFile, setMultiFile] = useState(false);
	const [mediaPreview, setMediaPreview] = useState(false);
	const attachInputRef = useRef(null);
	const [preview] = useState(false);
	const [loadingEnviarArquivos, setLoadingEnviarArquivos] = useState(false);
	const [figurinhas, setFigurinhas] = useState([]);
	const [figurinhasLoaded, setFigurinhasLoaded] = useState(false);
	const [loadingFigurinhas, setLoadingFigurinhas] = useState(false);
	const [creatingFigurinha, setCreatingFigurinha] = useState(false);
	const isDesktop = useResponsive('up', 'md');

	// O rollback do balão otimista agora é feito por removeMensagemEnviarById, que
	// filtra dentro do reducer — não é mais preciso espelhar mensagensEnviar numa
	// ref para escapar da closure antiga do selector.

	useEffect(() => {
		setFigurinhas([]);
		setFigurinhasLoaded(false);
	}, [chat?.sessao]);

	const [loadingSendText, setLoadingSendText] = useState(false);
	const [assinarEnvio, setAssinarEnvio] = useState(true);
	const assinatura = '*_' + user.nomeFantasia + '_* \n';
	const assinaturaMeta = user.nomeFantasia + ':\n\n';
	const [pesquisaRespostaRapida, setPesquisaRespostaRapidas] = useState('');
	const [listaRepostasRapidas, setListaRespostasRapidas] = useState([]);
	const [loadingRespostasRapidas, setLoadingRespostasRapidas] = useState(false);
	const [erroRespostasRapidas, setErroRespostasRapidas] = useState(false);
	const sendingRespostaRapidaRef = useRef(false);
	const [isDocument, setIsDocument] = useState(() => readSendAsDocument(chat));
	const [isFromMsgTemplate, setIsFromMsgTemplate] = useState(false);

	// A barra não remonta ao trocar de conversa, então recarrega a preferência
	// salva do contato atual (e não a do contato anterior).
	const sendAsDocumentKey = getSendAsDocumentKey(chat);
	useEffect(() => {
		setIsDocument(readSendAsDocument(chat));
	}, [sendAsDocumentKey]); // eslint-disable-line react-hooks/exhaustive-deps

	const changeIsDocument = useCallback(checked => {
		setIsDocument(checked);
		writeSendAsDocument(chat, checked);
	}, [sendAsDocumentKey]); // eslint-disable-line react-hooks/exhaustive-deps

	/// audio recorder v2
	const [recording, setRecording] = useState(false);
	const [audioURL, setAudioURL] = useState('');
	const mediaRecorderRef = useRef(null);
	const audioChunksRef = useRef([]);
	// Snapshot da conversa no início da gravação: se o usuário trocar de chat
	// antes do onstop, `chat` da closure já é outra conversa.
	const recordingChatRef = useRef(null);
	const [openPopoverNotes, setOpenPopoverNotes] = useState(false);
	const [textNotes, setTextNotes] = useState('');
	const [suggestion, setSuggestion] = useState("");
	const [dialogTemplates, setDialogTemplates] = useState(false);
	const [dialogTemplatesMessenger, setDialogTemplatesMessenger] = useState(false);
	// Só oferece o botão de templates do Messenger se a Página tiver algum aprovado —
	// abrir um modal vazio no meio do bloqueio de 24h só frustra.
	const [temTemplatesMessenger, setTemTemplatesMessenger] = useState(false);
	const [openInstagramInfo, setOpenInstagramInfo] = useState(false);
	const [openMessengerInfo, setOpenMessengerInfo] = useState(false);
	const [openModalProduct, setOpenModalProduct] = useState(false);
	const [loadingSuggestion, setLoadingSuggestion] = useState(false);
	const abortControllerRef = useRef(null);

	// Estado para habilitar/desabilitar copilot (persistido em localStorage)
	const [copilotEnabled, setCopilotEnabled] = useState(() => {
		const saved = localStorage.getItem('copilot_enabled');
		return saved !== null ? JSON.parse(saved) : false; // Desabilitado por padrão
	});

	const { toast } = useToast()

	const [loadingAnalysis, setLoadingAnalysis] = useState(false);

	// Persistir preferência do copilot
	const handleToggleCopilot = useCallback((enabled) => {
		setCopilotEnabled(enabled);
		localStorage.setItem('copilot_enabled', JSON.stringify(enabled));
		if (!enabled) {
			setSuggestion("");
		}
	}, []);

	// Comandos disponíveis para o copilot
	const COPILOT_COMMANDS = {
		'/r': { type: 'response', label: 'Gerar resposta baseada no contexto' },
		'/responda': { type: 'response', label: 'Gerar resposta baseada no contexto' },
		'/a': { type: 'analyze', label: 'Analisar conversa e sugerir resposta' },
		'/analise': { type: 'analyze', label: 'Analisar conversa e sugerir resposta' },
		'/s': { type: 'summary', label: 'Resumir conversa' },
		'/resuma': { type: 'summary', label: 'Resumir conversa' },
	};

	// Detectar se é um comando
	const detectCommand = useCallback((inputText) => {
		const trimmed = inputText.trim().toLowerCase();
		for (const [cmd, config] of Object.entries(COPILOT_COMMANDS)) {
			if (trimmed === cmd || trimmed.startsWith(cmd + ' ')) {
				const args = trimmed.slice(cmd.length).trim();
				return { ...config, cmd, args };
			}
		}
		return null;
	}, []);

	// Pegar contexto mínimo (só para comandos)
	const getMinimalContext = useCallback(() => {
		return mensagens
			.filter((item) => item.type === 'chat' && item.body)
			.slice(-6)
			.map((item) => `${item.fromMe ? 'A' : 'C'}: ${item.body?.substring(0, 150)}`)
			.join('\n');
	}, [mensagens]);

	const fetchSuggestion = useCallback(async (currentText) => {
		if (abortControllerRef.current) {
			abortControllerRef.current.abort();
		}
		abortControllerRef.current = new AbortController();
		setLoadingSuggestion(true);

		try {
			const command = detectCommand(currentText);
			let messages;

			if (command) {
				// Modo COMANDO - usa contexto completo
				const context = getMinimalContext();

				if (command.type === 'response') {
					messages = [
						{ role: "system", content: `Gere uma resposta profissional para o cliente baseada no contexto.\nContexto:\n${context}` },
						{ role: "user", content: command.args || "Responda adequadamente" }
					];
				} else if (command.type === 'analyze') {
					messages = [
						{ role: "system", content: `Analise a conversa e sugira a melhor resposta.\nContexto:\n${context}` },
						{ role: "user", content: command.args || "Qual a melhor resposta?" }
					];
				} else if (command.type === 'summary') {
					messages = [
						{ role: "system", content: `Resuma a conversa em 1-2 frases.\nContexto:\n${context}` },
						{ role: "user", content: "Resuma" }
					];
				}
			} else {
				// Modo AUTOCOMPLETE - mínimo de tokens
				// Só pega última mensagem do cliente para contexto mínimo
				const lastClientMsg = mensagens
					.filter(m => m.type === 'chat' && !m.fromMe && m.body)
					.slice(-1)[0]?.body?.substring(0, 100) || '';

				messages = [
					{
						role: "user",
						content: `Complete:${lastClientMsg ? ` [Cliente: ${lastClientMsg}]` : ''} "${currentText}"`
					}
				];
			}

			const response = await axios.post(
				`https://api.lais.app/api/v3/${cliente._id}/ai/copilot/completions`,
				{
					messages,
					model: "basic",
					temperature: command ? 0.4 : 0.1,
					purpose: "copilot",
					description: command ? command.type : "autocomplete"
				},
				{
					signal: abortControllerRef.current.signal,
					timeout: 6000
				}
			);

			const generatedText = response.data?.data?.trim() || "";

			if (generatedText && generatedText.length > 0 && generatedText.length < 500) {
				setSuggestion(generatedText);
			} else {
				setSuggestion("");
			}
		} catch (error) {
			if (error.name !== 'CanceledError' && error.code !== 'ERR_CANCELED') {
				console.error("Erro copilot:", error);
			}
			setSuggestion("");
		} finally {
			setLoadingSuggestion(false);
		}
	}, [cliente._id, detectCommand, getMinimalContext, mensagens]);

	// Debounce effect para buscar sugestões
	useEffect(() => {
		if (!copilotEnabled) {
			setSuggestion("");
			return;
		}

		const command = detectCommand(text);

		// Para comandos: buscar imediatamente após digitar o comando
		if (command) {
			const debounceTimeout = setTimeout(() => {
				fetchSuggestion(text);
			}, 400);
			return () => {
				clearTimeout(debounceTimeout);
				if (abortControllerRef.current) abortControllerRef.current.abort();
			};
		}

		// Para autocomplete: só buscar se texto > 8 chars (reduz chamadas)
		if (text.length < 8) {
			setSuggestion("");
			return;
		}

		if (loadingSendText || shouldBlockInput()) {
			return;
		}

		const debounceTimeout = setTimeout(() => {
			fetchSuggestion(text);
		}, 500);

		return () => {
			clearTimeout(debounceTimeout);
			if (abortControllerRef.current) abortControllerRef.current.abort();
		};
	}, [text, loadingSendText, fetchSuggestion, copilotEnabled, detectCommand]);

	// Limpar sugestão quando o componente desmontar
	useEffect(() => {
		return () => {
			if (abortControllerRef.current) {
				abortControllerRef.current.abort();
			}
		};
	}, []);

	const handleChangeAssinarEnvio = (event) => {
		setAssinarEnvio(event);
	};

	const buscarListaResponstasRapidas = async () => {
		setLoadingRespostasRapidas(true);
		setErroRespostasRapidas(false);
		try {
			const res = await actionListaRespostasRapida(user.clienteId);
			setListaRespostasRapidas(res.data.respostas || []);
		} catch (error) {
			console.error('Erro ao carregar respostas rápidas', error);
			setErroRespostasRapidas(true);
		} finally {
			setLoadingRespostasRapidas(false);
		}
	}

	const handleClickOpenDialogRespostasRapidas = () => {
		setPesquisaRespostaRapidas('');
		dispatch(setDialogRespostas(true));
		buscarListaResponstasRapidas()
	}

	const handleOnPaste = (event) => {
		const items = (event.clipboardData || event.originalEvent.clipboardData).items;
		let blob = null;
		for (let i = 0; i < items.length; i++) {
			if (items[i].type.indexOf("image") === 0) {
				blob = items[i].getAsFile();
			}
		}

		if (blob !== null) {
			openAttachmentFlow([blob]);
		}
	};

	// Filtra os arquivos pelos limites da Meta ANTES de abrir qualquer editor/dialog
	// (cobre colar imagem, arrastar no card e o input de anexo — todos passam por
	// aqui via openAttachmentFlow — e o dropzone do dialog legado via handleDropMultiFile).
	// No-op para canais que não são instagram.
	function filtrarArquivosPorCanal(acceptedFiles) {
		if (chat?.canal !== 'instagram') return acceptedFiles;
		const { aceitos, rejeitados } = partitionInstagramFiles(acceptedFiles);
		rejeitados.forEach(({ file, reason, kind, maxBytes }) => {
			const descricao = reason === 'format'
				? t('chat.upload.instagram.rejectedFormat', { name: file.name })
				: t('chat.upload.instagram.rejectedSize', { name: file.name, size: fData(maxBytes) });
			toast({ variant: 'destructive', description: descricao });
		});
		return aceitos;
	}

	// Roteia anexos: imagem/vídeo/PDF abrem o editor de pré-visualização (estilo
	// WhatsApp Web); demais tipos caem no dialog legado. Com o editor aberto,
	// novos arquivos são acrescentados ao lote.
	function openAttachmentFlow(acceptedFiles) {
		if (!acceptedFiles || acceptedFiles.length === 0) return;
		const permitidos = filtrarArquivosPorCanal(acceptedFiles);
		if (permitidos.length === 0) return;
		const mapped = permitidos.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) }));
		if (mediaPreview) {
			// Com o editor aberto, só entram tipos que ele suporta
			const supported = mapped.filter((file) => isEditorSupported([file], chat?.canal));
			if (supported.length < mapped.length) {
				toast({
					variant: 'destructive',
					description: t('chat:mediaEditor.unsupportedFileSkipped'),
				});
			}
			if (supported.length > 0) {
				setFiles((prev) => [...prev, ...supported]);
			}
			return;
		}
		setFiles(mapped);
		if (isEditorSupported(permitidos, chat?.canal)) {
			setMediaPreview(true);
		} else {
			setMultiFile(true);
		}
	}


	const handleDropMultiFile = useCallback(
		(acceptedFiles) => {
			const permitidos = filtrarArquivosPorCanal(acceptedFiles);
			if (permitidos.length === 0) return;
			setFiles(permitidos.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) })));
			setMultiFile(true);
		},
		[setFiles, chat?.canal]
	);

	const handleRemoveAll = () => {
		setFiles([]);
	};

	const handleRemove = (file) => {
		const filteredItems = files.filter((_file) => _file !== file);
		setFiles(filteredItems);
	};

	const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
		onDrop: (acceptedFiles, rejectedFiles) => {
			console.log('Accepted files:', acceptedFiles);
			console.log('Rejected files:', rejectedFiles);
			if (acceptedFiles && acceptedFiles.length > 0) {
				openAttachmentFlow(acceptedFiles);
			}
		},
		onDropAccepted: (files) => {
			console.log('Files accepted:', files);
		},
		onDropRejected: (files) => {
			console.log('Files rejected:', files);
		}
	});

	// Propaga o erro: antes o catch só fazia console.log e a resposta citada
	// falhava em silêncio — o texto sumia do input como se tivesse sido enviado.
	async function onResponderMensagemWhatsapp(phone, meesageId, message, clientMessageId) {
		let data = {
			phone: phone,
			messageId: meesageId,
			message: message,
			...(clientMessageId && { clientMessageId }),
		};
		const querys = `?sessao=${chatInfo.sessao}&canal=${chatInfo.canal}`;
		await v1_actionResponderMensagemWhatsapp(querys, data);
	}

	const onChangeText = e => {
		setText(e.target.value);
		// Reset da flag quando o usuário edita o texto manualmente
		if (isFromMsgTemplate) {
			setIsFromMsgTemplate(false);
		}
		// Limpar sugestão quando o texto mudar significativamente
		if (suggestion && !e.target.value.startsWith(text)) {
			setSuggestion("");
		}
	}

	useEffect(() => {
		const ta = textareaRef.current;
		if (!ta) return;
		if (isExpanded) {
			ta.style.height = '';
			return;
		}
		ta.style.height = 'auto';
		const maxHeight = 200;
		ta.style.height = `${Math.min(ta.scrollHeight, maxHeight)}px`;
	}, [text, isExpanded]);

	// Janela de atendimento do WhatsApp Business: a regra vive em
	// src/utils/serviceWindow.utils.js, que trata grupo (groupServiceWindowOpenedAt) e as
	// 72h que a Meta concede quando a conversa veio de um anúncio (Click-to-WhatsApp).
	// Diferencia "nunca houve contato" de "janela expirada" no texto do banner abaixo.
	const shouldBlockForMissingLastDate = () => isWhatsappBusiness(chat) && !hasServiceWindowReference(chat);

	const shouldBlockWhatsAppBusiness = () => shouldBlockWhatsAppBusinessWindow(chat);

	// Instagram e Messenger também têm janela de 24h a partir da última mensagem do
	// cliente, que a Meta guarda dentro do objeto do usuário da plataforma
	// (instagramUser/messengerUser.lastDateMessageUser) — isServiceWindowExpired resolve a
	// referência por canal. Aqui não há variação de 72h: só o WhatsApp Business tem
	// conversa de anúncio. Depois de expirar não existe envio ativo no Instagram (o
	// reengajamento só acontece pelo app) e no Messenger só via template da Página.
	const shouldBlockInstagram = () => chat?.canal === "instagram" && isServiceWindowExpired(chat);

	const shouldBlockMessenger = () => chat?.canal === "messenger" && isServiceWindowExpired(chat);

	// Bloqueio unificado do input por janela de atendimento expirada (WhatsApp Business, Instagram ou Messenger)
	const shouldBlockInput = () => {
		return shouldBlockWhatsAppBusiness() || shouldBlockInstagram() || shouldBlockMessenger();
	};

	// Descobre se a Página tem template aprovado, para decidir entre oferecer o botão de
	// templates ou apenas explicar como reengajar. Só consulta quando o canal é Messenger e
	// a janela já fechou — em conversa aberta o dado não é usado.
	// Sem `chat?.sessao` no guard: esse campo vem de um lookup que casa pelo sessao PADRAO
	// do cliente (herdado da época de 1 canal por cliente) e nunca bate com o sessao
	// próprio da Página — cai vazio pra Messenger. O backend resolve o canal mesmo sem
	// sessao (assume a única Página Messenger do cliente, ver resolverCanalMessenger).
	useEffect(() => {
		if (chat?.canal !== 'messenger' || !chat?.cliente_id || !shouldBlockMessenger()) {
			setTemTemplatesMessenger(false);
			return;
		}

		let cancelado = false;
		v1_actionMessengerTemplates(chat.cliente_id, { sessao: chat.sessao, status: 'APPROVED', limit: 1 })
			.then((res) => {
				if (!cancelado) setTemTemplatesMessenger((res.data?.data?.templates || []).length > 0);
			})
			.catch(() => {
				// Canal sem Página conectada ou sem permissão: cai no texto de reengajamento
				if (!cancelado) setTemTemplatesMessenger(false);
			});

		return () => { cancelado = true; };
	}, [chat?._id, chat?.canal, chat?.cliente_id, chat?.sessao, chat?.messengerUser?.lastDateMessageUser]); // eslint-disable-line react-hooks/exhaustive-deps

	// Função para lidar com seleção de template
	const handleSelecionouTemplate = (template) => {
		if (template.tipo === 'texto') {
			setText(template.resposta);
			setIsFromMsgTemplate(true);
			setDialogTemplates(false);
		}
	};

	// Envio de texto para grupos WhatsApp Business (Meta Cloud API): usa o endpoint
	// dedicado de grupo (recipient_type: group) em vez do fluxo 1:1, que não se aplica
	// (grupos não têm numeroCliente nem suportam resposta citada via onResponderMensagemWhatsapp).
	async function sendGroupTextMessage(textToSend) {
		if (text === '' || text === '\n' || text === ' ' || text === ' \n') {
			setText('');
			return;
		}
		const chatSent = chat;
		const messageBody = assinarEnvio && user.nomeFantasia !== "" ? assinatura + textToSend : textToSend;
		setText('');
		setSuggestion("");
		setIsFromMsgTemplate(false);
		if (selectedMessage) dispatch(setSelectedMessage({}));
		setLoadingSendText(true);
		const optimisticId = await setMensagensEnviarRedux({ type: 'chat', isMedia: false, chatSent });
		const rollbackOtimista = () => {
			if (optimisticId) {
				dispatch(removeMensagemEnviarById(optimisticId));
			} else if (chatSent?._id) {
				dispatch(removeMensagensEnviarByChatId(chatSent._id));
			} else {
				dispatch(resetMensagensEnviar());
			}
		};
		try {
			const result = await dispatch(sendGroupMessage(chatSent._id, {
				type: 'text',
				text: { body: messageBody }
			}));
			if (!result?.success) {
				rollbackOtimista();
				toast({
					variant: 'destructive',
					description: result?.message || t('notifications:toast.sendError'),
				});
				return;
			}
			dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
		} catch (error) {
			rollbackOtimista();
			toast({
				variant: 'destructive',
				description: t('notifications:toast.sendError'),
			});
			Sentry.withScope(scope => {
				scope.setTag("section", "sendGroupTextMessage");
				scope.setLevel("error");
				scope.setExtra("chat", chatSent);
				Sentry.captureException(error);
			});
		} finally {
			setLoadingSendText(false);
		}
	}

	// Texto legível da falha, na melhor fonte disponível: código traduzido →
	// mensagem do backend → timeout → código HTTP. Usado tanto no aviso quanto no
	// balão de erro que fica na conversa.
	function descreverErroEnvio(error) {
		const data = error?.response?.data;
		const codigo = resolveSendErrorCode(error);
		const chaveTraducao = SEND_ERROR_TRANSLATIONS[codigo];

		if (chaveTraducao) {
			const base = t(chaveTraducao);
			return codigo === 'GENERIC' && data?.detalhe ? `${base}: ${data.detalhe}` : base;
		}
		if (data?.mensagem) return data.mensagem;
		if (error?.code === 'ECONNABORTED') return t('chat.errors.timeout');
		return t('notifications:toast.sendErrorCode', { code: error?.response?.status || error?.code || 'NF01' });
	}

	// A Meta recusou o envio por janela fechada (131047). Pode acontecer dentro das 72h
	// de uma conversa de anúncio, porque as 72h são um teto: a free entry point pode ter
	// sido consumida antes. Marca o fechamento na hora para a tela virar modo template em
	// vez de deixar o atendente retentando — o backend grava o mesmo campo no chat, então
	// o estado sobrevive ao reload.
	function fecharJanelaCtwaLocal(error, chatSent) {
		if (resolveSendErrorCode(error) !== 'WINDOW_EXPIRED') return;
		const chatId = (chatSent || chat)?._id;
		const fechadoEm = new Date();
		dispatch(updateChatInfoField('ctwaWindowClosedAt', fechadoEm));
		if (chatId) dispatch(updateChatList({ _id: chatId, scope: { ctwaWindowClosedAt: fechadoEm } }));
	}

	// Todo erro de envio de texto passa por aqui: o atendente SEMPRE recebe um
	// aviso, com o motivo real quando o backend souber informá-lo.
	function notificarErroEnvio(error) {
		const codigo = resolveSendErrorCode(error);
		const texto = descreverErroEnvio(error);
		fecharJanelaCtwaLocal(error);

		if (SEND_ERROR_MODAL_CODES.includes(codigo)) {
			dispatch(setModalAlerta({
				open: true,
				// Título traduzido junto com o corpo: config.erroDesconexaoWhatsapp é
				// pt-BR fixo e deixava o modal metade em português, metade em inglês.
				titulo: codigo === 'DISCONNECTED' ? t('chat.errors.connectionTitle') : t('chat.errors.sendFailed'),
				mensagem: texto,
			}));
			return;
		}

		toast({
			variant: 'destructive',
			description: texto,
		});
	}

	async function sendMessage() {
		const chatSent = chat;
		const clienteSent = cliente;
		const clientMessageId = (typeof crypto !== 'undefined' && crypto.randomUUID)
			? crypto.randomUUID()
			: `${Date.now()}_${Math.random().toString(36).slice(2)}`;
		let textToSend = cliente?.config?.chats?.removeHttp ? removeHttpPrefix(text) : text;
		if (chatSent.isGroup === true) {
			return sendGroupTextMessage(textToSend);
		}
		// Canais de pagina Meta (Instagram/Messenger). Nada aqui toca os fluxos de
		// whatsapp / whatsapp_business, que seguem no else abaixo.
		if (chatSent.canal === "instagram" || chatSent.canal === "messenger") {
			try {
				const replyToMid = selectedMessage?.metaMid || selectedMessage?.id || null;
				// UUID otimista / ObjectId do Mongo nao sao mid da Meta — sem mid real
				// a API devolve 2534002 ("ID da mensagem invalido ou mensagem excluida").
				const isLikelyMetaMid = replyToMid
					&& typeof replyToMid === 'string'
					&& replyToMid.length > 40
					&& !/^[a-f0-9]{24}$/i.test(replyToMid)
					&& !/^[0-9a-f-]{36}$/i.test(replyToMid);
				const safeReplyMid = isLikelyMetaMid ? replyToMid : null;
				if (replyToMid && !safeReplyMid) {
					console.warn('[meta] reply ignorado: id nao parece mid da Meta', replyToMid);
				}

				const quotedOptimistic = selectedMessage && safeReplyMid ? {
					id: safeReplyMid,
					type: selectedMessage.type || 'chat',
					body: selectedMessage.body || '',
					caption: selectedMessage.caption || '',
					fromMe: !!selectedMessage.fromMe,
					mediaUrl: selectedMessage.mediaUrl,
					isMetaMedia: selectedMessage.isMetaMedia,
					mimetype: selectedMessage.mimetype,
				} : null;

				let querys = `?sessao=${chatSent.sessao}&canal=${chatSent.canal}`;
				let body = {
					userId: chatSent.canal === "messenger" ? chatSent.messengerUser?.id : chatSent.instagramUser?.id,
					message: user.nomeFantasia !== "" ? text : text,
					clientMessageId,
					...(isFromMsgTemplate && { fromMsgTemplate: true }),
					...(safeReplyMid && { messageId: safeReplyMid }),
				}
				setText('');
				setSuggestion("");
				setIsFromMsgTemplate(false);
				if (selectedMessage) dispatch(setSelectedMessage({}));
				// Atualizacao OTIMISTA (mesma logica do WhatsApp): a mensagem enviada aparece
				// imediatamente em mensagensEnviar. A reconciliacao por body no handler de
				// socket (newMessageInstagram/newMessageMessenger) remove esta quando chega o
				// echo real da Meta. body/type identicos aos do WhatsApp para o balao renderizar.
				const nowSecMeta = Date.now() / 1000;
				dispatch(setMensagensEnviar({
					ack: 6,
					preSend: true,
					fromMe: true,
					isMedia: false,
					type: 'chat',
					id: clientMessageId,
					body: body.message,
					content: body.message,
					t: nowSecMeta,
					timestamp: nowSecMeta,
					cliente_id: user.clienteId,
					chat_id: chatSent._id,
					platform: chatSent.canal,
					...(quotedOptimistic && {
						quotedMsg: quotedOptimistic,
						quotedMsgId: safeReplyMid,
					}),
				}));
				// Preview na lista lateral. No WhatsApp quem faz isso e o socket do echo
				// (updateChatList em initIO); nos canais Meta o backend nao persiste nem
				// emite nada no envio, entao a conversa ficaria com a mensagem antiga
				// ate o echo da Meta chegar (se chegar). Atualiza otimista aqui.
				const agoraIso = new Date().toISOString();
				dispatch(updateChatList({
					_id: chatSent._id,
					scope: {
						dataUltimaMensagem: agoraIso,
						lastUpdate: agoraIso,
						lastMessageWpp: {
							type: 'chat',
							message: body.message,
							fromMe: true,
							timestamp: nowSecMeta,
							ack: 1,
							id: clientMessageId,
						},
					},
				}));
				dispatch(reorderChatsAtendimento());
				// Sem getChatsAtendimento apos o envio: o POST Meta nao grava nada no
				// banco, entao o refetch traria a lista com a mensagem anterior e
				// desfaria o preview acima. Quem reconcilia e o echo da Meta.
				await v1_actionEnviarMenagemWhatsapp(querys, body);

				setLoadingSendText(false);
			} catch (error) {
				// Sem echo/persistencia no envio, um erro deixaria o balao otimista girando
				// para sempre — remove so ele (nao um resetMensagensEnviar, que apagaria
				// outros envios em andamento) e devolve o texto ao input.
				dispatch(removeMensagemEnviarById(clientMessageId));
				setText(textToSend);
				setLoadingSendText(false);
				// O backend devolve o texto real da Meta em `mensagem` (janela de 24h
				// fechada, permissão faltando...) e ele era descartado por um toast
				// genérico. Mesmo critério do handler de arquivos, que já mostra o
				// erro específico nos canais Meta.
				notificarErroEnvio(error);
				Sentry.withScope(scope => {
					scope.setTag("section", "sendMessageMeta");
					scope.setLevel("error");
					scope.setExtra("chat", chatSent);
					Sentry.captureException(error);
				});
			}
		} else {
			if (text === '' || text === '\n' || text === ' ' || text === ' \n') {
				setText('');
				return;
			}
			if (selectedMessage) {
				const mensagemResposta = assinarEnvio && user.nomeFantasia !== "" ? assinatura + textToSend : textToSend;
				const respostaCitada = selectedMessage;
				setText('');
				setSuggestion("");
				dispatch(setSelectedMessage({}));
				try {
					await onResponderMensagemWhatsapp(chat.numeroCliente, respostaCitada.id, mensagemResposta, clientMessageId);
					dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
				} catch (error) {
					// A resposta citada não gera balão de erro com reenvio, então
					// devolve texto e citação ao input, além de avisar o motivo.
					notificarErroEnvio(error);
					setText(textToSend);
					dispatch(setSelectedMessage({ message: respostaCitada }));
					Sentry.withScope(scope => {
						scope.setTag("section", "onResponderMensagemWhatsapp");
						scope.setLevel("error");
						scope.setExtra("chat", chat);
						scope.setExtra("cliente", cliente);
						Sentry.captureException(error);
					});
				} finally {
					setLoadingSendText(false);
				}
				return;

			} else {
				// Id do balão otimista, para o rollback remover só ele em caso de erro.
				let optimisticId = null;
				try {
					// issues=1 faz o backend confirmar no gateway se o número existe
					// quando o envio falha (só no canal whatsapp, que é o único a usar
					// esse parâmetro). Sem isso a detecção dependia do texto do erro do
					// WPPConnect e qualquer mudança de redação deixava o atendente sem
					// saber que o número não existe.
					let querys = `?sessao=${chatSent.sessao}&canal=${chatSent.canal}${chatSent.canal === "whatsapp" ? "&issues=1" : ""}`;
					let body;
					let dataPreSend = { type: 'chat', isMedia: false, };
					// telegram usa o mesmo contrato { phone, message }: a chave da conversa
					// ("TG.<chat_id>") vive em numeroCliente, como no whatsapp/webchat.
					if (chatSent.canal === "whatsapp" || chatSent.canal === "webchat" || chatSent.canal === "telegram") {
						body = {
							phone: chatSent.numeroCliente,
							message: assinarEnvio && user.nomeFantasia !== "" ? assinatura + textToSend : textToSend,
							clientMessageId,
							...(isFromMsgTemplate && { fromMsgTemplate: true })
						}
					} else if (chatSent.canal === "whatsapp_business") {
						body = {
							clientMessageId,
							scope: {
								"messaging_product": "whatsapp",
								"recipient_type": "individual",
								"to": chatSent.numeroCliente,
								"type": "text",
								"text": {
									"body": assinarEnvio && user.nomeFantasia !== "" ? assinatura + textToSend : textToSend
								}
							}
						}
					}
					setText('');
					setSuggestion("");
					setIsFromMsgTemplate(false);
					optimisticId = await setMensagensEnviarRedux({
						...dataPreSend,
						chatSent,
						clienteSent,
						bodyText: body?.message || (assinarEnvio && user.nomeFantasia !== "" ? assinatura + textToSend : textToSend),
					});
					const response = await v1_actionEnviarMenagemWhatsapp(querys, body);
					// if(chat.canal === "whatsapp_business"){
					// 	if(response.data.data.send){
					// 		dataPreSend.ack = 2;
					// 		dataPreSend.preSend = false;
					// 	}
					// }

					dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
				} catch (error) {
					notificarErroEnvio(error);
					Sentry.withScope(scope => {
						scope.setTag("section", "sendMessage");
						scope.setLevel("error");
						scope.setExtra("user", user);
						scope.setExtra("chat", chatSent);
						scope.setExtra("message", {
							phone: chatSent.numeroCliente,
							message: assinarEnvio && user.nomeFantasia !== "" ? assinatura + textToSend : textToSend
						});
						scope.setExtra("cliente", clienteSent);
						Sentry.captureException(error);
					});
					setText('');
					setLoadingSendText(false);
					// Rollback pontual: resetMensagensEnviar() derrubava os balões
					// pendentes de TODAS as conversas — inclusive um envio legítimo
					// em andamento em outra, que sumia da tela sem explicação.
					if (optimisticId) {
						dispatch(removeMensagemEnviarById(optimisticId));
					} else if (chatSent?._id) {
						dispatch(removeMensagensEnviarByChatId(chatSent._id));
					} else {
						dispatch(resetMensagensEnviar());
					}
					await saveMessageToIDB('error_msg_send', {
						"ack": -1,
						"preSend": false,
						"body": assinarEnvio && user.nomeFantasia !== "" ? assinatura + textToSend : textToSend,
						"chatId": `${chatSent.numeroCliente}`,
						"content": assinarEnvio && user.nomeFantasia !== "" ? assinatura + textToSend : textToSend,
						"from": `${clienteSent.numero}@c.us`,
						"fromMe": true,
						"mimeType": false,
						"id": `${chatSent._id}_${Math.floor((new Date()).getTime() / 1000) + Math.random().toString(15).substring(2, 7)}`,
						"isGroupMsg": false,
						"isMedia": false,
						"sender": {
							"formattedName": "",
							"id": `${clienteSent.numero}@c.us`,
							"isMe": true,
							"profilePicThumbObj": null,
							"pushname": "",
							"verifiedName": ""
						},
						"t": new Date().getTime() / 1000,
						"timestamp": new Date().getTime() / 1000,
						"to": `${chatSent.numeroCliente}@c.us`,
						"type": "chat",
						"cliente_id": user.clienteId,
						"chat_id": chatSent._id,
						"error_msg": true,
						"errorMessage": {
							code: error?.response?.status || error?.code || 'NF01',
							message: descreverErroEnvio(error),
						},
					});

					if (chat?._id === chatSent._id) {
						onCallbackResend();
					}

				}
			}

		}
	}

	async function setMensagensEnviarRedux(props) {
		const { type, isMedia, mimeType, erroMsg, ack = 6, preSend = true, chatSent, clienteSent, bodyText } = props;
		const targetChat = chatSent || chat;
		const targetCliente = clienteSent || cliente;
		const content = bodyText ?? (assinarEnvio && user.nomeFantasia !== "" ? assinatura + text : text);
		let newId = `true_${targetChat.numeroCliente}_${Math.floor((new Date()).getTime() / 1000) + Math.random().toString(15).substring(2, 7)}`;
		const novaData = new Date();
		try {
			let data = {
				"ack": ack,
				"preSend": preSend,
				"body": content,
				"chatId": `${targetChat.numeroCliente}`,
				"content": content,
				"from": `${targetCliente.numero}@c.us`,
				"fromMe": true,
				"mimeType": mimeType,
				"id": newId,
				"isGroupMsg": false,
				"isMedia": isMedia,
				"sender": {
					"formattedName": "",
					"id": `${targetCliente.numero}@c.us`,
					"isMe": true,
					"profilePicThumbObj": null,
					"pushname": "",
					"verifiedName": ""
				},
				"t": novaData.getTime() / 1000,
				"timestamp": novaData.getTime() / 1000,
				"to": `${targetChat.numeroCliente}@c.us`,
				"type": type,
				"cliente_id": user.clienteId,
				"chat_id": targetChat._id
			}
			dispatch(setMensagensEnviar(data))
			// Devolve o id para quem chamou conseguir remover só este balão no
			// rollback, em vez de limpar a fila inteira de todas as conversas.
			return newId;
		} catch (error) {
			console.log(error)
			return null;
		}

	}

	async function handleSelecinouRespostaRapida(resposta) {
		if (resposta.tipo === 'texto') {
			setText(resposta.resposta);
			setIsFromMsgTemplate(true);
			dispatch(setDialogRespostas(false));
		} else {
			const respostaFiles = Array.isArray(resposta.files) ? resposta.files : [];
			if (sendingRespostaRapidaRef.current) return;
			sendingRespostaRapidaRef.current = true;
			setLoadingSendText(true);
			dispatch(setDialogRespostas(false));
			if (respostaFiles.length === 0) {
				setLoadingSendText(false);
				sendingRespostaRapidaRef.current = false;
				toast({
					variant: 'destructive',
					description: t('notifications:toast.quickReplyNoFiles'),
				});


				return;
			}
			let key = respostaFiles[0].key || '';
			let type = respostaFiles[0].type || '';
			const chatSent = chat;
			const res_buffer = await v1_actionUrlToBuffer(`https://lais-app.s3.us-east-2.amazonaws.com/${key}`)
			let querys = `?sessao=${chatSent.sessao}&canal=${chatSent.canal}`;

			try {
				if (type === 'audio/mp3') {
					await setMensagensEnviarRedux({ type: 'ptt', isMedia: true, mimeType: 'audio/mp3', chatSent })

					// Criar FormData para áudio
					const formData = new FormData();
					const filename = `${new Date().getTime()}_audio.mp3`;
					const blob = new Blob([res_buffer.data], { type: 'audio/mp3' });
					formData.append("filename", filename);
					formData.append("file", blob);
					formData.append("phone", chatSent.numeroCliente);

					await v2_actionEnviarAudioBuffer(querys, formData);
					setLoadingEnviarArquivos(false);
					setLoadingSendText(false);
				} else {
					// Criar FormData para outros arquivos
					const formData = new FormData();
					const filename = `${new Date().getTime()}_${cliente?.nome || 'arquivo'}`;
					const blob = new Blob([res_buffer.data], { type: type });
					formData.append("filename", filename);
					formData.append("file", blob);
					formData.append("phone", chatSent.numeroCliente);

					await v1_actionEnviarArquivoBuffer(querys, formData);
				}
				toast({
					description: t('notifications:toast.sentSuccess'),
				});
				dispatch(removeMensagensEnviarByChatId(chatSent._id));
				setLoadingEnviarArquivos(false);
				setLoadingSendText(false);

			} catch (error) {
				console.log('error', error)
				toast({
					variant: 'destructive',
					description: t('notifications:toast.sendError'),
				});

				dispatch(removeMensagensEnviarByChatId(chatSent._id));
				setLoadingEnviarArquivos(false);
				setLoadingSendText(false);
				setIsFromMsgTemplate(false);
			} finally {
				sendingRespostaRapidaRef.current = false;
			}
		}
	}

	// Envio unificado de arquivo para todos os canais via enviar-arquivo-buffer.
	// whatsapp/whatsapp_business aceitam caption direto no FormData; para
	// instagram/messenger o backend exige o campo scope e a legenda vai como
	// mensagem de texto logo após o anexo (a API Meta não suporta caption).
	async function sendSingleFileBuffer(file, { caption, isDocument: sendAsDocument } = {}) {
		const isMetaChannel = chat.canal === "instagram" || chat.canal === "messenger";
		const isInstagram = chat.canal === "instagram";

		// Revalidacao final: o editor de midia pode reexportar a imagem como PNG/JPEG
		// (media-editor/utils/imageExport.js) e estourar o limite de 8MB mesmo que o
		// arquivo original tivesse passado na selecao inicial. Sem isso, o backend
		// manda pra Meta e ela recusa com um 500 opaco.
		if (isInstagram) {
			const result = validateInstagramFile(file);
			if (!result.ok) {
				const descricao = result.reason === 'format'
					? t('chat.upload.instagram.rejectedFormat', { name: file.name })
					: t('chat.upload.instagram.rejectedSize', { name: file.name, size: fData(result.maxBytes) });
				toast({ variant: 'destructive', description: descricao });
				const rejectionError = new Error('instagram-media-rejected');
				rejectionError.skipGenericHandler = true;
				throw rejectionError;
			}
		}

		const formData = new FormData();
		formData.append("filename", `${new Date().getTime()}_${file.name}`);
		formData.append("file", file);
		if (sendAsDocument) formData.append("isDocument", true);
		if (isMetaChannel) {
			const attachmentType = isInstagram
				? (getInstagramMediaKind(file) || "file")
				: (validaTipoArquivo(file.type) || (file?.type?.startsWith('audio/') ? 'audio' : 'file'));
			const scopePayload = {
				messageType: "response",
				type: attachmentType,
				instagramUserId: chat.instagramUser?.id,
				messengerUserId: chat.messengerUser?.id,
				...(selectedMessage?.metaMid && { replyToMid: selectedMessage.metaMid }),
				...(!selectedMessage?.metaMid && selectedMessage?.id && selectedMessage.id.length > 40 && { replyToMid: selectedMessage.id }),
			};
			formData.append("scope", JSON.stringify(scopePayload));
		} else {
			formData.append("phone", chat.numeroCliente);
			if (caption) formData.append("caption", caption);
		}
		const querys = `?sessao=${chat.sessao}&canal=${chat.canal}`;

		await v1_actionEnviarArquivoBuffer(querys, formData);

		if (selectedMessage && isMetaChannel) {
			dispatch(setSelectedMessage({}));
		}

		if (caption && isMetaChannel) {
			await v1_actionEnviarMenagemWhatsapp(querys, {
				userId: chat.canal === "messenger" ? chat.messengerUser?.id : chat.instagramUser?.id,
				message: caption,
			});
		}
	}

	// Guarda o arquivo que falhou como balão de erro na conversa (com o blob no
	// cache), do mesmo jeito que o envio de texto já fazia. Sem isto, um arquivo
	// que falhava simplesmente sumia da tela: nada para reenviar, nada para
	// mostrar que existiu uma tentativa.
	async function registrarFalhaDeArquivo(file, { isDocument: comoDocumento, caption, error, chatSent } = {}) {
		const targetChat = chatSent || chat;
		if (!file || !targetChat?._id) return;
		try {
			const id = `${targetChat._id}_${Math.floor((new Date()).getTime() / 1000)}${Math.random().toString(15).substring(2, 7)}`;
			// resendMsg lê o arquivo por getImageBlob(msg.id) — mesma store usada
			// pelo áudio que falha.
			await storeImageBlob(id, file);
			const tipo = comoDocumento ? 'document' : (validaTipoArquivo(file.type) || 'document');
			const agora = new Date().getTime() / 1000;
			await saveMessageToIDB('error_msg_send', {
				"ack": -1,
				"preSend": false,
				"body": caption || file.name || '',
				"caption": caption || '',
				"chatId": `${targetChat.numeroCliente}`,
				"content": caption || file.name || '',
				"from": `${cliente.numero}@c.us`,
				"fromMe": true,
				"mimeType": file.type,
				"mimetype": file.type,
				"filename": file.name,
				"id": id,
				"isGroupMsg": false,
				"isMedia": true,
				"type": tipo,
				"sender": {
					"formattedName": "",
					"id": `${cliente.numero}@c.us`,
					"isMe": true,
					"profilePicThumbObj": null,
					"pushname": "",
					"verifiedName": ""
				},
				"t": agora,
				"timestamp": agora,
				"to": `${targetChat.numeroCliente}@c.us`,
				"cliente_id": user.clienteId,
				"chat_id": targetChat._id,
				"error_msg": true,
				...(error && {
					errorMessage: {
						code: error?.response?.status || error?.code || 'NF01',
						message: descreverErroEnvio(error),
					},
				}),
			});
			if (chat?._id === targetChat._id) {
				onCallbackResend();
			}
		} catch (err) {
			// Cache cheio/indisponível: o toast do erro original já foi mostrado.
			console.error('Erro ao registrar falha de arquivo:', err);
		}
	}

	// rollback: 'reset' (padrao) limpa mensagensEnviar inteiro — comportamento
	// historico dos fluxos de whatsapp. 'none' deixa o rollback a cargo de quem
	// chamou, para envios que precisam remover so o proprio balao otimista.
	// file: quando informado, a falha vira balao de erro reenviavel na conversa.
	function handleSendFileError(error, { rollback = 'reset', file, isDocument: comoDocumento, caption, chatSent } = {}) {
		const responseError = error?.response?.data;
		fecharJanelaCtwaLocal(error, chatSent);
		const isMetaChannel = chat?.canal === "instagram" || chat?.canal === "messenger";
		if (error?.response?.status === 400) {
			if (responseError?.statusConexao === "Disconnected") {
				dispatch(setModalAlerta({
					open: true,
					// Mesmo texto do erro de desconexão no envio de texto — antes o
					// envio de arquivo usava a string fixa em pt-BR de src/config.
					titulo: t('chat.errors.connectionTitle'),
					mensagem: t('chat.errors.channelDisconnected'),
				}))
			}
		}
		// Erro real da Meta propagado pelo backend (branch instagram) — mostra a
		// mensagem especifica (formato nao suportado, janela de 24h fechada, etc.)
		// em vez do toast generico. Nos canais Meta vale para qualquer mensagem que
		// o backend devolva: a falha de conversao do audio para M4A responde 500 com
		// 'mensagem' e sem metaErrorCode, e ficava mascarada como erro generico.
		const mensagemEspecifica = (responseError?.metaErrorCode || responseError?.telegramErrorCode || isMetaChannel)
			? responseError?.mensagem
			: null;
		toast({
			variant: 'destructive',
			description: mensagemEspecifica || t('notifications:toast.sendError'),
		});

		if (rollback === 'reset') {
			const targetId = (chatSent || chat)?._id;
			if (targetId) dispatch(removeMensagensEnviarByChatId(targetId));
			else dispatch(resetMensagensEnviar());
		}
		if (file) registrarFalhaDeArquivo(file, { isDocument: comoDocumento, caption, error, chatSent });
		Sentry.withScope(scope => {
			scope.setTag("section", "onEnviarArquivosBuffer");
			scope.setLevel("error");
			scope.setExtra("user", user);
			scope.setExtra("chat", chat);
			scope.setExtra("cliente", cliente);
			Sentry.captureException(error);
		});
	}

	// Fluxo do dialog legado (tipos não cobertos pelo editor de mídia)
	async function onEnviarArquivosBuffer() {
		if (files.length === 0) return;
		const chatSent = chat;
		setLoadingEnviarArquivos(true);
		try {
			const optimisticId = await setMensagensEnviarRedux({ type: 'video', isMedia: true, mimeType: 'video/mp4', chatSent })
			setMultiFile(false);
			for (let file of files.map(item => item)) {
				try {
					await sendSingleFileBuffer(file, { isDocument });
					if (optimisticId) dispatch(removeMensagemEnviarById(optimisticId));
					else dispatch(removeMensagensEnviarByChatId(chatSent._id));
					toast({
						description: t('notifications:toast.sentSuccess'),
					});
				} catch (error) {
					// Rejeicao de validacao (formato/tamanho do Instagram): o toast
					// especifico ja foi mostrado em sendSingleFileBuffer — so limpa o
					// estado de envio, sem o toast generico nem o report pro Sentry.
					if (error?.skipGenericHandler) {
						if (optimisticId) dispatch(removeMensagemEnviarById(optimisticId));
						else dispatch(removeMensagensEnviarByChatId(chatSent._id));
					} else {
						handleSendFileError(error, { file, isDocument, chatSent });
					}
				}
			}
		} finally {
			setLoadingEnviarArquivos(false);
			setMultiFile(false);
			setFiles([]);
		}
	}

	// Biblioteca de figurinhas (compartilhada por cliente) — busca, criação, envio e remoção
	async function fetchFigurinhas() {
		if (figurinhasLoaded || loadingFigurinhas) return;
		setLoadingFigurinhas(true);
		try {
			const response = await v1_actionListarFigurinhas(`?sessao=${chat.sessao}`);
			setFigurinhas(response.data?.data || []);
			setFigurinhasLoaded(true);
		} catch (error) {
			toast({
				variant: 'destructive',
				description: t('notifications:toast.loadError'),
			});
		} finally {
			setLoadingFigurinhas(false);
		}
	}

	async function handleCreateFigurinha(file) {
		setCreatingFigurinha(true);
		try {
			const formData = new FormData();
			formData.append('file', file);
			formData.append('sessao', chat.sessao);
			formData.append('userId', user.id);
			const response = await v1_actionCriarFigurinha(formData);
			const novaFigurinha = response.data?.data;
			if (novaFigurinha) {
				setFigurinhas((prev) => [novaFigurinha, ...prev]);
			}
		} catch (error) {
			toast({
				variant: 'destructive',
				description: t('notifications:toast.sendError'),
			});
		} finally {
			setCreatingFigurinha(false);
		}
	}

	async function handleSendFigurinhaSalva(figurinha) {
		const chatSent = chat;
		let optimisticId = null;
		try {
			optimisticId = await setMensagensEnviarRedux({ type: 'sticker', isMedia: true, mimeType: figurinha.mimetype, chatSent });
			await v1_actionEnviarFigurinhaSalva(figurinha._id, {
				sessao: chatSent.sessao,
				canal: chatSent.canal,
				phone: chatSent.numeroCliente,
			});
			if (optimisticId) dispatch(removeMensagemEnviarById(optimisticId));
			else dispatch(removeMensagensEnviarByChatId(chatSent._id));
			toast({
				description: t('notifications:toast.sentSuccess'),
			});
		} catch (error) {
			if (optimisticId) dispatch(removeMensagemEnviarById(optimisticId));
			else dispatch(removeMensagensEnviarByChatId(chatSent._id));
			handleSendFileError(error, { chatSent, rollback: 'none' });
		}
	}

	async function handleDeleteFigurinha(figurinha) {
		try {
			await v1_actionDeletarFigurinha(figurinha._id, `?sessao=${chat.sessao}`);
			setFigurinhas((prev) => prev.filter((item) => item._id !== figurinha._id));
		} catch (error) {
			toast({
				variant: 'destructive',
				description: t('notifications:toast.sendError'),
			});
		}
	}

	// Fluxo do editor de pré-visualização (imagem/PDF/vídeo, com legenda e edições)
	async function onEnviarArquivosEditor(processedItems) {
		if (!processedItems || processedItems.length === 0) return;
		const chatSent = chat;
		setLoadingEnviarArquivos(true);
		try {
			for (const item of processedItems) {
				let optimisticId = null;
				try {
					optimisticId = await setMensagensEnviarRedux({
						type: item.isDocument ? 'document' : validaTipoArquivo(item.file.type) || 'document',
						isMedia: true,
						mimeType: item.file.type,
						chatSent,
					});
					await sendSingleFileBuffer(item.file, item);
					if (optimisticId) dispatch(removeMensagemEnviarById(optimisticId));
					else dispatch(removeMensagensEnviarByChatId(chatSent._id));
					toast({
						description: t('notifications:toast.sentSuccess'),
					});
				} catch (error) {
					if (error?.skipGenericHandler) {
						if (optimisticId) dispatch(removeMensagemEnviarById(optimisticId));
						else dispatch(removeMensagensEnviarByChatId(chatSent._id));
					} else {
						handleSendFileError(error, {
							file: item.file,
							isDocument: item.isDocument,
							caption: item.caption,
							chatSent,
							rollback: optimisticId ? 'none' : 'reset',
						});
						if (optimisticId) dispatch(removeMensagemEnviarById(optimisticId));
					}
				}
			}
		} finally {
			setLoadingEnviarArquivos(false);
			setMediaPreview(false);
			setFiles([]);
		}
	}


	function validaTipoArquivo(mime) {
		// MediaRecorder pode reportar "audio/webm;codecs=opus" — normaliza antes do match.
		const base = (mime || '').split(';')[0].trim().toLowerCase();
		const includesImage = ["image/png", "image/jpg", "image/jpeg"];
		const includesVideo = ["video/webm", "video/ogg", "video/mp4", "video/avi"];
		const includesAudio = ["audio/webm", "audio/ogg", "audio/wav", "audio/mpeg", "audio/mp3", "audio/mp4", "audio/aac", "audio/x-m4a", "audio/m4a"];

		if (includesImage.includes(base)) {
			return "image";
		} else if (includesVideo.includes(base)) {
			return "video";
		} else if (includesAudio.includes(base) || base.startsWith("audio/")) {
			return "audio";
		}
	}

	const v2_startRecording = async () => {
		if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
			toast({
				variant: 'destructive',
				description: t('chat.audio.notSupported'),
			});
			return;
		}

		try {
			recordingChatRef.current = chat;
			audioChunksRef.current = [];
			const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
			mediaRecorderRef.current = new MediaRecorder(stream);
			mediaRecorderRef.current.ondataavailable = (event) => {
				if (event.data && event.data.size > 0) {
					audioChunksRef.current.push(event.data);
				}
			};
			mediaRecorderRef.current.start();

			setRecording(true);
		} catch (err) {
			console.error('Erro ao acessar microfone:', err.name, err.message);

			// Tenta fallback com dispositivo explícito e sem filtros de áudio
			if (err.name === 'NotReadableError' || err.name === 'NotAllowedError' || err.name === 'AbortError') {
				try {
					const devices = await navigator.mediaDevices.enumerateDevices();
					const audioDevices = devices.filter(d => d.kind === 'audioinput');
					console.log('Dispositivos de áudio encontrados:', audioDevices);

					if (audioDevices.length === 0) {
						toast({
							variant: 'destructive',
							description: t('chat.audio.noMicrophone'),
						});
						return;
					}

					// Tenta com o primeiro dispositivo explicitamente
					recordingChatRef.current = chat;
					audioChunksRef.current = [];
					const stream = await navigator.mediaDevices.getUserMedia({
						audio: {
							deviceId: { exact: audioDevices[0].deviceId },
							echoCancellation: false,
							noiseSuppression: false,
							autoGainControl: false,
						}
					});

					mediaRecorderRef.current = new MediaRecorder(stream);
					mediaRecorderRef.current.ondataavailable = (event) => {
						if (event.data && event.data.size > 0) {
							audioChunksRef.current.push(event.data);
						}
					};
					mediaRecorderRef.current.start();
					setRecording(true);
					return;
				} catch (retryErr) {
					console.error('Fallback também falhou:', retryErr.name, retryErr.message);
				}
			}

			const mensagensErro = {
				NotAllowedError: t('chat.audio.permissionDenied'),
				NotFoundError: t('chat.audio.noMicrophone'),
				NotReadableError: t('chat.audio.microphoneInUse'),
			};

			toast({
				variant: 'destructive',
				description: mensagensErro[err.name] || t('chat.audio.genericError', { code: err.name }),
			});
		}
	};

	const v2_handleCancelAudio = async () => {
		try {
			mediaRecorderRef.current.stop();
			mediaRecorderRef.current.onstop = async () => {
				setRecording(false);
				audioChunksRef.current = [];
				setLoading(false);
			}
		} catch (err) {
			console.log(err);
		}
	};

	// const resendAudio = async (messageId, blob) => {
	// 	if (chat.canal === "whatsapp") {
	// 		try {
	// 			await setMensagensEnviarRedux({ type: 'ptt', isMedia: true, mimeType: 'audio/mp3' });

	// 			setLoading(true);
	// 			const formData = new FormData();
	// 			const filename = `${new Date().getTime()}.mp3`;
	// 			formData.append("filename", filename);
	// 			formData.append("file", blob);
	// 			formData.append("phone", chat.numeroCliente);
	// 			let querys = `?sessao=${chat.sessao}&canal=${chat.canal}`;
	// 			await v2_actionEnviarAudioBuffer(querys, formData);
	// 			dispatch(resetMensagensEnviar())
	// 			await removeMessageFromIDB('error_msg_send', messageId)
	// 		} catch (err) {
	// 			setLoading(false);
	// 			toast({
	// 				variant: 'destructive',
	// 				description: t('notifications:toast.sendError'),
	// 			});

	// 		}

	// 	}
	// }


	const v2_stopRecording = async () => {

		let audioBlobSave;
		const recorder = mediaRecorderRef.current;
		if (!recorder) return;

		recorder.onstop = async () => {
			const chatSent = recordingChatRef.current || chat;
			const canal = chatSent?.canal;
			const realMime = recorder?.mimeType || 'audio/webm';
			const chunks = audioChunksRef.current || [];
			if (canal === "whatsapp" || canal === "whatsapp_business") {
				try {
					await setMensagensEnviarRedux({ type: 'ptt', isMedia: true, mimeType: 'audio/mp3', chatSent });
					const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/mp3' });
					audioBlobSave = audioBlob;
					setLoading(true);
					const formData = new FormData();
					const filename = `${new Date().getTime()}.mp3`;
					formData.append("filename", filename);
					formData.append("file", audioBlob);
					formData.append("phone", chatSent.numeroCliente);
					formData.append("isVoice", "true");
					let querys = `?sessao=${chatSent.sessao}&canal=${chatSent.canal}`;
					if (chatSent.canal === "whatsapp_business") {
						await v1_actionEnviarArquivoBuffer(querys, formData);
					} else {
						await v2_actionEnviarAudioBuffer(querys, formData);
					}

					dispatch(removeMensagensEnviarByChatId(chatSent._id))

				} catch (err) {

					const messageId = `${chatSent._id}_${Math.floor((new Date()).getTime() / 1000)}_${Math.random().toString(15).substring(2, 7)}`;
					const base64Audio = await blobToBase64(audioBlobSave);
					await initCacheFileSave(messageId, base64Audio, 'audio/mp3');

					await saveMessageToIDB('error_msg_send', {
						"ack": -1,
						"preSend": false,
						"body": null,
						"chatId": `${chatSent.numeroCliente}`,
						"content": messageId,
						"from": `${cliente.numero}@c.us`,
						"fromMe": true,
						"mimeType": "audio/mp3",
						"id": messageId,
						"isGroupMsg": false,
						"isMedia": true,
						"type": "ptt",
						"sender": {
							"formattedName": "",
							"id": `${cliente.numero}@c.us`,
							"isMe": true,
							"profilePicThumbObj": null,
							"pushname": "",
							"verifiedName": ""
						},
						"t": new Date().getTime() / 1000,
						"timestamp": new Date().getTime() / 1000,
						"to": `${chatSent.numeroCliente}@c.us`,
						"cliente_id": user.clienteId,
						"chat_id": chatSent._id,
						"error_msg": true,
					});
					dispatch(removeMensagensEnviarByChatId(chatSent._id))
					setLoading(false);
					setRecording(false);
					Sentry.captureException(err);

				}

			}
			else if (canal === "telegram") {
				try {
					setLoading(true);
					await setMensagensEnviarRedux({ type: 'ptt', isMedia: true, mimeType: 'audio/ogg', chatSent });
					// Preserva o mimetype real do MediaRecorder (o navegador grava em
					// webm/opus, não mp3): o backend reencodifica para OGG/OPUS, o único
					// formato que o sendVoice do Telegram aceita como mensagem de voz.
					const ext = realMime.includes('ogg') ? 'ogg' : realMime.includes('mp4') ? 'mp4' : 'webm';
					const audioBlob = new Blob(audioChunksRef.current, { type: realMime });
					const formData = new FormData();
					const filename = `${new Date().getTime()}.${ext}`;
					formData.append("filename", filename);
					formData.append("file", audioBlob);
					formData.append("phone", chatSent.numeroCliente);
					formData.append("isVoice", "true");
					const querys = `?sessao=${chatSent.sessao}&canal=${chatSent.canal}`;
					await v1_actionEnviarArquivoBuffer(querys, formData);
					dispatch(removeMensagensEnviarByChatId(chatSent._id));
				} catch (err) {
					handleSendFileError(err, { chatSent });
				}
			}
			else if (canal === "instagram" || canal === "messenger") {
				// O gravador do navegador nao usa mp3 de verdade (Chrome/Firefox gravam
				// em webm/opus por padrao) — preserva o mimetype real do MediaRecorder.
				// Backend: Instagram reencodifica pra M4A; Messenger pra MP3. A Graph API
				// aceita attachment type "audio" nos dois canais.
				const ext = realMime.includes('ogg') ? 'ogg' : realMime.includes('mp4') ? 'mp4' : 'webm';
				const audioBlob = new Blob(chunks, { type: realMime });

				if (!audioBlob.size) {
					toast({
						variant: 'destructive',
						description: t('chat.audio.genericError', { code: 'EMPTY' }),
					});
				} else {
					// Balao otimista: ao contrario do WhatsApp, o backend nao persiste nem
					// emite nada no envio dos canais Meta, entao sem isto o audio some da
					// tela ate o echo da Meta chegar — e o atendente reenvia achando que
					// falhou. preSend faz o balao renderizar o placeholder de "enviando"
					// sem precisar de mediaUrl. Quem remove e reconciliarMensagemOtimista
					// (initIO), que casa por body vazio quando o echo chega.
					const clientMessageId = (typeof crypto !== 'undefined' && crypto.randomUUID)
						? crypto.randomUUID()
						: `${Date.now()}_${Math.random().toString(36).slice(2)}`;
					const nowSecMeta = Date.now() / 1000;
					try {
						setLoading(true);
						const audioFile = new File([audioBlob], `voice_${Date.now()}.${ext}`, { type: realMime });
						dispatch(setMensagensEnviar({
							ack: 6,
							preSend: true,
							fromMe: true,
							isMedia: true,
							type: 'ptt',
							id: clientMessageId,
							body: '',
							content: '',
							mimeType: realMime,
							t: nowSecMeta,
							timestamp: nowSecMeta,
							cliente_id: user.clienteId,
							chat_id: chatSent._id,
							platform: canal,
						}));
						await sendSingleFileBuffer(audioFile, {});
						// Preview na lista lateral — mesmo motivo do balao otimista: sem
						// persistencia no envio, a conversa ficaria com a mensagem antiga.
						const agoraIso = new Date().toISOString();
						dispatch(updateChatList({
							_id: chatSent._id,
							scope: {
								dataUltimaMensagem: agoraIso,
								lastUpdate: agoraIso,
								lastMessageWpp: {
									type: 'ptt',
									message: '',
									fromMe: true,
									timestamp: nowSecMeta,
									ack: 1,
									id: clientMessageId,
								},
							},
						}));
						dispatch(reorderChatsAtendimento());
					} catch (err) {
						// Rollback pontual (nao resetMensagensEnviar, que apagaria outros
						// envios em andamento) — por isso o handler generico nao reseta.
						dispatch(removeMensagemEnviarById(clientMessageId));
						if (!err?.skipGenericHandler) {
							handleSendFileError(err, { rollback: 'none', chatSent });
						}
					}
				}
			}
			// Libera o microfone apos parar a gravacao
			try {
				recorder.stream?.getTracks?.().forEach((track) => track.stop());
			} catch (_) { /* ignore */ }
			setRecording(false);
			setLoading(false);
			audioChunksRef.current = [];
			recordingChatRef.current = null;
		};

		recorder.stop();
	};


	const handleKeyDown = (event) => {
		if (!event.shiftKey && event.key === 'Enter') {
			event.preventDefault();
			sendMessage();
		} else if (event.key === "Tab" && suggestion) {
			event.preventDefault();
			const command = detectCommand(text);
			if (command) {
				// Para comandos: substitui tudo pela sugestão
				setText(suggestion);
			} else {
				// Para autocomplete: concatena
				const newText = text + " " + suggestion;
				setText(newText.trim());
			}
			setSuggestion("");
		}
	};

	const handleKeyUp = (event) => {
		// Outras lógicas que você possa ter no handleKeyUp
	};


	async function handleAddNote() {
		try {
			let data = {
				nota: {
					body: textNotes,
					usuario_id: user.id,
					date: new Date()
				}
			}
			await actionCriarNotas(chat._id, data)
			setTextNotes('');
			dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, false));
			dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
			setOpenPopoverNotes(false);
			toast({
				description: t('notifications:toast.noteAddedSuccess'),
			});

		} catch (error) {
			toast({
				variant: 'destructive',
				description: t('notifications:toast.sendError'),
			});

		}
	}

	const onCreateAnalysis = async () => {
		try {
			setLoadingAnalysis(true);

			enqueueSnackbar(t('notifications:toast.analysisSuccess'), {
				variant: 'success',
				anchorOrigin: {
					vertical: 'bottom',
					horizontal: 'center'
				},
				autoHideDuration: 3000
			});

			await v2_actionAnaliseAtendimento({
				chat_id: chat._id,
				cliente_id: user.clienteId
			});

		} catch (error) {
			console.error('Erro na análise:', error);
			enqueueSnackbar(t('notifications:toast.analysisError'), {
				variant: 'error',
				anchorOrigin: {
					vertical: 'bottom',
					horizontal: 'center'
				}
			});
		} finally {
			setLoadingAnalysis(false);
		}
	};

	const handleSelectProduct = async (product) => {
		try {
			// setOpenModalProduct(false); 
			// Should close modal? The previous code didn't close it explicitly here, maybe the modal handles it or it stays open?
			// The modal prop `onSelect` is called. Let's see `ModalSearchProduct` usage.
			// Line 1249: onSelect={handleSelectProduct}. And onClose is separate.
			// Usually onSelect implies action taken. If I want to close it, I should call setOpenModalProduct(false).
			// But maybe the user wants to send multiple?
			// The previous logic just added text to input.
			// I'll assume closing it or keeping it is fine. I'll just keep the API logic.

			setLoadingSendText(true);
			// await axios.post(`/api/v1/chats/canais/enviar-produto?sessao=${chat.sessao}&canal=${chat.canal}`, {
			// 	produtoId: product._id,
			// 	phone: chat.numeroCliente
			// });
			const querys = `?sessao=${chat.sessao}&canal=${chat.canal}`;
			await v1_actionEnviarProduto(querys, {
				produtoId: product._id,
				phone: chat.numeroCliente
			});

			toast({
				description: t('notifications:toast.productSentSuccess'),
			});
			setOpenModalProduct(false);

		} catch (error) {
			console.error(error);
			toast({
				variant: 'destructive',
				description: t('notifications:toast.productSendError'),
			});
		} finally {
			setLoadingSendText(false);
		}
	};

	return (
		<Card {...getRootProps()} className={`mx-2 ${layoutMode === 'sidebar' ? 'mb-20' : 'mb-2'}`} style={{
			cursor: 'pointer',
			border: isDragActive ? '2px dashed #0aafd9' : '',
		}}>
			<MultiFileDialog
				open={multiFile}
				files={files}
				onOpenChange={(open) => {
					setMultiFile(open);
					if (!open) setLoadingEnviarArquivos(false);
				}}
				chat={chat}
				cliente={cliente}
				isDocument={isDocument}
				loadingEnviarArquivos={loadingEnviarArquivos}
				preview={preview}
				onEnviarArquivosBuffer={onEnviarArquivosBuffer}
				handleDropMultiFile={handleDropMultiFile}
				handleRemove={handleRemove}
				handleRemoveAll={handleRemoveAll}
				changeIsDocument={changeIsDocument}
			/>

			{mediaPreview && (
				<MediaPreviewOverlay
					containerRef={mediaOverlayRef}
					initialFiles={files}
					chat={chat}
					sending={loadingEnviarArquivos}
					onClose={() => {
						setMediaPreview(false);
						setFiles([]);
					}}
					onAddFiles={() => attachInputRef.current?.click()}
					onRemoveFile={(file) => setFiles((prev) => prev.filter((item) => item !== file))}
					onSend={onEnviarArquivosEditor}
				/>
			)}

			<ModalMensagensRapidas
				dialogRespostasRapidas={dialogRespostasRapidas}
				onClose={() => {
					dispatch(setDialogRespostas(false))
				}}
				data={listaRepostasRapidas}
				onSelect={resposta => handleSelecinouRespostaRapida(resposta)}
				changePesquisa={e => setPesquisaRespostaRapidas(e.target.value)}
				pesquisaRespostaRapida={pesquisaRespostaRapida}
				loading={loadingRespostasRapidas}
				error={erroRespostasRapidas}
				onRetry={buscarListaResponstasRapidas}
				onRefresh={buscarListaResponstasRapidas}
			/>

			<ModalTemplatesWhatsApp
				dialogTemplates={dialogTemplates}
				onClose={() => setDialogTemplates(false)}
				onSelect={handleSelecionouTemplate}
				chat={chat}
			/>

			{/* Utility messages do Messenger: envia direto (nao preenche o input), porque a
			    janela de 24h esta fechada e texto livre seria recusado pela Meta.
			    Sem getChatsAtendimento aqui, pelo mesmo motivo do envio de texto deste canal
			    (ver comentario em sendMessage): o POST Meta nao grava nada, o refetch traria a
			    lista sem a mensagem. Quem traz o balao e o webhook message_echoes. */}
			<ModalTemplatesMessenger
				dialogTemplates={dialogTemplatesMessenger}
				onClose={() => setDialogTemplatesMessenger(false)}
				chat={chat}
				onEnviado={() => {
					toast({ description: t('chat.templates.messenger.sent', 'Template enviado. A mensagem aparece no histórico em instantes.') });
				}}
			/>

			<ModalSearchProduct
				open={openModalProduct}
				onClose={() => setOpenModalProduct(false)}
				onSelect={handleSelectProduct}
				ownerId={cliente?._id || user.clienteId}
			/>

			{/* Explicação não-técnica de por que a janela do Instagram fechou */}
			<Dialog open={openInstagramInfo} onOpenChange={setOpenInstagramInfo}>
				<DialogContent className="max-w-[420px] p-6 gap-0 rounded-2xl">
					{/* Header limpo — o gradiente do Instagram fica apenas no badge do ícone */}
					<div className="flex items-center gap-3.5">
						<div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#feda75] via-[#d62976] to-[#4f5bd5] flex items-center justify-center flex-shrink-0 shadow-sm shadow-[#d62976]/25">
							<Instagram className="w-6 h-6 text-white" />
						</div>
						<div>
							<DialogTitle className="text-gray-900 text-[17px] leading-tight">
								{t('chat.input.instagramBlock.modalTitle')}
							</DialogTitle>
							<span className="inline-flex items-center gap-1 mt-1.5 text-[11px] font-medium text-amber-700 bg-amber-50 border border-amber-100 rounded-full px-2 py-0.5">
								<Clock className="w-3 h-3" />
								{t('chat.input.instagramBlock.modalBadge')}
							</span>
						</div>
					</div>

					{/* Corpo */}
					<p className="text-sm text-gray-600 leading-relaxed mt-5">
						{t('chat.input.instagramBlock.modalIntro')}
					</p>

					<p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400 mt-5 mb-3">
						{t('chat.input.instagramBlock.modalStepsTitle')}
					</p>
					<div className="space-y-1">
						{[
							{ Icon: MessageCircle, text: t('chat.input.instagramBlock.modalStep1') },
							{ Icon: Instagram, text: t('chat.input.instagramBlock.modalStep2') },
							{ Icon: RefreshCw, text: t('chat.input.instagramBlock.modalStep3') },
						].map((step, i, arr) => (
							<div key={i} className="flex gap-3">
								<div className="flex flex-col items-center">
									<div className="w-8 h-8 rounded-full bg-violet-50 flex items-center justify-center flex-shrink-0">
										<step.Icon className="w-4 h-4 text-violet-600" />
									</div>
									{i < arr.length - 1 && <div className="w-px flex-1 bg-gray-200 my-1" />}
								</div>
								<p className="text-sm text-gray-700 leading-relaxed pt-1.5 pb-2">
									{step.text}
								</p>
							</div>
						))}
					</div>

					{/* Rodapé */}
					<Button
						onClick={() => setOpenInstagramInfo(false)}
						className="w-full bg-[#7C3AED] hover:bg-[#6d28d9] rounded-xl h-11 shadow-sm shadow-[#7C3AED]/20 mt-5"
					>
						{t('common:buttons.understood')}
					</Button>
				</DialogContent>
			</Dialog>

			{/* Explicação não-técnica de por que a janela do Messenger fechou */}
			<Dialog open={openMessengerInfo} onOpenChange={setOpenMessengerInfo}>
				<DialogContent className="max-w-[420px] p-6 gap-0 rounded-2xl">
					{/* Header limpo — o gradiente do Messenger fica apenas no badge do ícone */}
					<div className="flex items-center gap-3.5">
						<div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#00B2FF] via-[#006AFF] to-[#A033FF] flex items-center justify-center flex-shrink-0 shadow-sm shadow-[#006AFF]/25">
							<MessageCircle className="w-6 h-6 text-white" />
						</div>
						<div>
							<DialogTitle className="text-gray-900 text-[17px] leading-tight">
								{t('chat.input.messengerBlock.modalTitle')}
							</DialogTitle>
							<span className="inline-flex items-center gap-1 mt-1.5 text-[11px] font-medium text-amber-700 bg-amber-50 border border-amber-100 rounded-full px-2 py-0.5">
								<Clock className="w-3 h-3" />
								{t('chat.input.messengerBlock.modalBadge')}
							</span>
						</div>
					</div>

					{/* Corpo */}
					<p className="text-sm text-gray-600 leading-relaxed mt-5">
						{t('chat.input.messengerBlock.modalIntro')}
					</p>

					<p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400 mt-5 mb-3">
						{t('chat.input.messengerBlock.modalStepsTitle')}
					</p>
					<div className="space-y-1">
						{[
							{ Icon: MessageCircle, text: t('chat.input.messengerBlock.modalStep1') },
							{ Icon: Facebook, text: t('chat.input.messengerBlock.modalStep2') },
							{ Icon: RefreshCw, text: t('chat.input.messengerBlock.modalStep3') },
						].map((step, i, arr) => (
							<div key={i} className="flex gap-3">
								<div className="flex flex-col items-center">
									<div className="w-8 h-8 rounded-full bg-violet-50 flex items-center justify-center flex-shrink-0">
										<step.Icon className="w-4 h-4 text-violet-600" />
									</div>
									{i < arr.length - 1 && <div className="w-px flex-1 bg-gray-200 my-1" />}
								</div>
								<p className="text-sm text-gray-700 leading-relaxed pt-1.5 pb-2">
									{step.text}
								</p>
							</div>
						))}
					</div>

					{/* Rodapé */}
					<Button
						onClick={() => setOpenMessengerInfo(false)}
						className="w-full bg-[#7C3AED] hover:bg-[#6d28d9] rounded-xl h-11 shadow-sm shadow-[#7C3AED]/20 mt-5"
					>
						{t('common:buttons.understood')}
					</Button>
				</DialogContent>
			</Dialog>


			{!!selectedMessage && (
				<div
					class="p-2 flex flex-row bg-slate-50 border-slate-200 rounded border items-center justify-center gap-2 ">
					<Scrollbar className="flex-1 max-h-32 overflow-y-auto">
						<div class="content flex-1 flex items-center justify-center">
							<ChatComponent
								isMe={selectedMessage.fromMe ? "right" : "left"}
								isWarning={!selectedMessage?.body && selectedMessage.type !== "chat" && !["ptt", "audio"].includes(selectedMessage.type)}
								chat={chatInfo}
								message={selectedMessage}
								isReply={true}
								selectMessageId={() => {
									// Removido scrollMessagesToBottom() que estava causando conflito
									dispatch(setSelectedMessage(selectedMessage))
								}}
							/>
						</div>
					</Scrollbar>
					<Button
						variant="ghost"
						size="icon"
						className="w-8 h-8 mr-12 rounded-lg text-gray-500 hover:text-gray-800"
						onClick={() => dispatch(setSelectedMessage({}))}
					>
						<X className="h-4 w-4" />
					</Button>
				</div>
			)}

			{/* Mostrar comandos disponíveis quando digitar "/" */}
			{copilotEnabled && text === '/' && (
				<div className="relative w-full">
					<div className="py-2 px-2 bg-slate-50 border border-slate-200 rounded">
						<p className="text-[11px] text-slate-500 mb-1">{t('chat.copilot.commandsAvailable')}</p>
						<div className="flex flex-wrap gap-1">
							<span className="text-[11px] bg-violet-100 text-violet-700 px-2 py-0.5 rounded">/r</span>
							<span className="text-[11px] text-slate-500">{t('chat.copilot.commands.response')}</span>
							<span className="text-[11px] bg-violet-100 text-violet-700 px-2 py-0.5 rounded ml-2">/a</span>
							<span className="text-[11px] text-slate-500">{t('chat.copilot.analysis')}</span>
							<span className="text-[11px] bg-violet-100 text-violet-700 px-2 py-0.5 rounded ml-2">/s</span>
							<span className="text-[11px] text-slate-500">{t('chat.copilot.commands.summary')}</span>
						</div>
					</div>
				</div>
			)}

			{/* Sugestão do copilot */}
			{copilotEnabled && text !== '/' && (suggestion || loadingSuggestion) && (
				<div
					className={`relative w-full transition-opacity duration-300 ${suggestion || loadingSuggestion ? "opacity-100" : "opacity-0"}`}
					tabIndex={0}
				>
					<div className="py-1 flex flex-row bg-violet-50 border border-violet-200 rounded-lg items-center px-2">
						<Sparkles className="text-violet-600 mr-2 flex-shrink-0 h-4 w-4" />

						<div className="flex-1 min-w-0 overflow-hidden">
							{loadingSuggestion ? (
								<p className='text-[12px] text-violet-400 italic'>
									{detectCommand(text) ? t('chat.copilot.generating') : t('chat.copilot.suggesting')}
								</p>
							) : (
								<p className='text-[12px]'>
									{detectCommand(text) ? (
										// Para comandos: mostra só a sugestão
										<span className="text-slate-700">{suggestion}</span>
									) : (
										// Para autocomplete: mostra texto + sugestão
										<>
											<span className="text-slate-700">{text}</span>
											<span className="text-violet-500 font-medium"> {suggestion}</span>
										</>
									)}
								</p>
							)}
						</div>

						{suggestion && !loadingSuggestion && (
							<span className="text-[10px] text-violet-400 ml-2 whitespace-nowrap bg-violet-100 px-1.5 py-0.5 rounded">
								Tab ↹
							</span>
						)}
					</div>
				</div>
			)}



			<div className="w-full p-2 flex flex-col">
				<div className="flex flex-col">
					<div className="flex flex-row">
						{loadingSendText ? (
							<div className="w-1/5 h-5 pt-1">
								<Progress value={undefined} className="h-1" />
							</div>
						) : (
							<div className='w-full flex items-center justify-between flex-wrap gap-y-1'>
								<div className="flex items-center gap-1 flex-row flex-wrap">

									<div className="flex flex-row items-center flex-shrink-0">
										<input
											ref={attachInputRef}
											type="file"
											multiple
											// No Instagram, restringe o seletor do SO aos formatos que a Meta
											// aceita — reduz a chance de rejeicao (o filtro real acontece de
											// qualquer forma em openAttachmentFlow, isso e so UX).
											accept={chat?.canal === 'instagram' ? INSTAGRAM_ACCEPT.join(',') : undefined}
											className="hidden"
											onChange={(e) => {
												openAttachmentFlow(Array.from(e.target.files || []));
												e.target.value = '';
											}}
										/>
										<TooltipProvider>
											<Tooltip>
												<TooltipTrigger asChild>
													<Button
														variant="ghost"
														size="icon"
														onClick={() => attachInputRef.current?.click()}
														disabled={shouldBlockInput()}
														className="h-8 w-8 rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100"
													>
														<Paperclip className="h-4 w-4" />
													</Button>
												</TooltipTrigger>
												<TooltipContent>
													{t('chat.upload.dialogTitle')}
												</TooltipContent>
											</Tooltip>
										</TooltipProvider>
										{["whatsapp", "whatsapp_business"].includes(chat.canal) && (
											<StickerPicker
												disabled={loadingEnviarArquivos || shouldBlockInput()}
												figurinhas={figurinhas}
												loading={loadingFigurinhas}
												creating={creatingFigurinha}
												onOpen={fetchFigurinhas}
												onCreate={handleCreateFigurinha}
												onSend={handleSendFigurinhaSalva}
												onDelete={handleDeleteFigurinha}
											/>
										)}
										{isDesktop && (
											<EmojiPicker
												disabled={disabled || shouldBlockInput()}
												value={text}
												setValue={setText}
											/>
										)}
										<TooltipProvider>
											<Tooltip>
												<TooltipTrigger asChild>
													<Button
														variant="ghost"
														size="icon"
														onClick={handleClickOpenDialogRespostasRapidas}
														disabled={shouldBlockInput()}
														className="h-8 w-8 rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100"
													>
														<MessageSquareShare className="h-4 w-4" />
													</Button>
												</TooltipTrigger>
												<TooltipContent>
													{t('chat.input.quickReplies')}
												</TooltipContent>
											</Tooltip>
										</TooltipProvider>
										{chat?.canal === "messenger" && (
											<TooltipProvider>
												<Tooltip>
													<TooltipTrigger asChild>
														<Button
															variant="ghost"
															size="icon"
															onClick={() => setDialogTemplatesMessenger(true)}
															className="h-8 w-8 rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100"
														>
															<FileText className="h-4 w-4" />
														</Button>
													</TooltipTrigger>
													<TooltipContent>
														{t('chat.templates.messenger.openShort', 'Templates')}
													</TooltipContent>
												</Tooltip>
											</TooltipProvider>
										)}
										{(verifyRules(user.rules, 'ia.analise-atendimento') || verifyRules(user.rules, 'chatgpt')) && (
											<DropdownMenu>
												<DropdownMenuTrigger asChild>
													<Button variant="ghost" size="icon" className="h-8 w-8 rounded-lg hover:bg-violet-50">
														<Sparkles className='text-[#7C3AED] h-4 w-4' />
													</Button>
												</DropdownMenuTrigger>
												<DropdownMenuContent>
													<DropdownMenuItem onClick={onOpenDrawerGpt}>
														{t('chat.copilot.title')}
													</DropdownMenuItem>

													{verifyRules(user.rules, 'ia.analise-atendimento') && (
														<DropdownMenuItem onClick={onCreateAnalysis} disabled={loadingAnalysis}>
															{loadingAnalysis ? (
																<div className="flex items-center gap-2">
																	<Loader2 className="h-4 w-4 animate-spin" />
																	<span>{t('chat.aiAnalysis.running')}</span>
																</div>
															) : (
																t('chat.aiAnalysis.title')
															)}
														</DropdownMenuItem>
													)}



												</DropdownMenuContent>
											</DropdownMenu>
										)}

										{/* {verifyRules(user.rules, 'chatgpt') || verifyRules(user.rules, 'analise') && (

										)} */}
									</div>
									<div className="flex items-center space-x-1 sm:space-x-2 flex-shrink-0">
										<TooltipProvider>
											<Tooltip>
												<TooltipTrigger asChild>
													<Button
														variant="ghost"
														size="icon"
														onClick={() => setOpenModalProduct(true)}
														disabled={shouldBlockInput()}
														className="h-8 w-8 mr-1 rounded-lg hover:bg-violet-50"
													>
														<Package className="text-[#7C3AED] h-4 w-4" />
													</Button>
												</TooltipTrigger>
												<TooltipContent>
													{t('chat.input.searchProduct')}
												</TooltipContent>
											</Tooltip>
										</TooltipProvider>

										{/* Só mostra switches quando não há bloqueio */}
										{!shouldBlockInput() && (
											<>
												<TooltipProvider>
													<Tooltip>
														<TooltipTrigger asChild>
															<Button
																variant="outline"
																role="switch"
																aria-checked={assinarEnvio}
																onClick={() => handleChangeAssinarEnvio(!assinarEnvio)}
																className={`h-8 px-2.5 rounded-full text-xs font-medium gap-1.5 ${assinarEnvio
																	? 'bg-violet-50 hover:bg-violet-100 border-violet-200 text-violet-700 hover:text-violet-700'
																	: 'text-gray-400 hover:text-gray-600'}`}
															>
																<PenLine className="h-3.5 w-3.5" />
																<span className="hidden sm:inline">{t('chat.input.sign')}</span>
																<span className={`relative inline-flex h-4 w-7 items-center rounded-full transition-colors ${assinarEnvio ? 'bg-[#7C3AED]' : 'bg-gray-300'}`}>
																	<span className={`inline-block h-3 w-3 rounded-full bg-white shadow transition-transform ${assinarEnvio ? 'translate-x-[14px]' : 'translate-x-0.5'}`} />
																</span>
															</Button>
														</TooltipTrigger>
														<TooltipContent>
															{t('chat.input.sign')}
														</TooltipContent>
													</Tooltip>
												</TooltipProvider>

												<div className="border-l border-slate-300 h-4 mx-1 sm:mx-2 hidden sm:block" />

												{/* <Tooltip title="Sugestões de texto com IA (Tab para aceitar)">
													<div className="flex items-center space-x-1">
														<Switch
															checked={copilotEnabled}
															onCheckedChange={handleToggleCopilot}
															id="copilot-mode"
															className="data-[state=checked]:bg-violet-600"
														/>
														<Label htmlFor="copilot-mode" className="flex items-center gap-1 cursor-pointer">
															<Iconify icon="mingcute:ai-line" className={copilotEnabled ? "text-violet-600" : "text-slate-400"} width={14} height={14} />
															<span className="text-xs">Copilot</span>
														</Label>
													</div>
												</Tooltip> */}
											</>
										)}
									</div>
									{isWhatsappBusiness(chat) && hasServiceWindowReference(chat) && (
										<WhatsAppCountdownTimer
											expiresAt={getWindowExpiresAt(chat)}
											isCtwa={isCtwaWindowGoverning(chat)}
										/>
									)}
									{(chat?.canal === "instagram" || chat?.canal === "messenger") && hasServiceWindowReference(chat) && (
										<WhatsAppCountdownTimer expiresAt={getWindowExpiresAt(chat)} />
									)}
								</div>



								<NotesPopover
									open={openPopoverNotes}
									setOpen={setOpenPopoverNotes}
									textNotes={textNotes}
									setTextNotes={setTextNotes}
									handleAddNote={handleAddNote}
								/>

								{/* Contador de tempo para WhatsApp Business */}


								{/* {chat?.canal === "instagram" && (
									<Tooltip title="Tempo restante para interação com o contato">
										<Stack spacing={.3} direction={"row"} alignItems={"center"}>
											<Iconify color="primary" icon="mingcute:time-line" width={18} height={18} />
											<CountdownTimer sx={{ ml: 2 }} targetDate={chat?.instagramUser?.lastDateMessageUser ? chat?.instagramUser?.lastDateMessageUser : "2024-05-54T21:00:00"} />
										</Stack>
									</Tooltip>
								)} */}
							</div>
						)}

					</div>



					<div className="flex flex-row items-center">
						{/* Verifica se deve bloquear o input por janela de atendimento expirada */}
						{shouldBlockInstagram() ? (
							// Instagram: janela de 24h fechada — reengajamento só pelo app do Instagram
							<div
								className="flex items-center justify-between w-full bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mt-2 cursor-pointer hover:bg-amber-100 transition-colors"
								onClick={() => setOpenInstagramInfo(true)}
							>
								<div className="flex items-center gap-2">
									<Instagram className="w-[18px] h-[18px] text-amber-500" />
									<div>
										<p className="text-xs text-amber-700 font-medium">
											{t('chat.input.instagramBlock.windowExpired')}
										</p>
										<p className="text-xs text-amber-600">
											{t('chat.input.instagramBlock.reengage')}
										</p>
									</div>
								</div>
								<Info className="w-4 h-4 text-amber-500" />
							</div>
						) : shouldBlockMessenger() ? (
							// Messenger: janela de 24h fechada. As utility messages (templates de
							// Pagina) sao o caminho de reengajamento — mesmo papel dos templates no
							// WhatsApp Business. O botao de templates so aparece quando a Pagina tem
							// template aprovado; sem isso resta a explicacao de como reengajar.
							<div className="flex items-center justify-between w-full bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mt-2 gap-2">
								<div
									className="flex items-center gap-2 flex-1 min-w-0 cursor-pointer"
									onClick={() => (temTemplatesMessenger ? setDialogTemplatesMessenger(true) : setOpenMessengerInfo(true))}
								>
									<MessageCircle className="w-[18px] h-[18px] text-amber-500 flex-shrink-0" />
									<div className="min-w-0">
										<p className="text-xs text-amber-700 font-medium">
											{t('chat.input.messengerBlock.windowExpired')}
										</p>
										<p className="text-xs text-amber-600">
											{temTemplatesMessenger
												? t('chat.input.messengerBlock.useTemplates', 'Use um template de utility message para reabrir a conversa.')
												: t('chat.input.messengerBlock.reengage')}
										</p>
									</div>
								</div>

								{temTemplatesMessenger ? (
									<Button
										size="sm"
										onClick={() => setDialogTemplatesMessenger(true)}
										className="h-8 px-3 rounded-lg bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-xs font-medium flex-shrink-0 gap-1.5"
									>
										<FileText className="w-3.5 h-3.5" />
										{t('chat.templates.messenger.openShort', 'Templates')}
									</Button>
								) : (
									<Info
										className="w-4 h-4 text-amber-500 cursor-pointer flex-shrink-0"
										onClick={() => setOpenMessengerInfo(true)}
									/>
								)}
							</div>
						) : shouldBlockWhatsAppBusiness() ? (
							// Mostra apenas botão para templates quando tempo expirou
							<div
								className="flex items-center justify-between w-full bg-red-50 border border-red-200 rounded-lg px-3 py-2 mt-2 cursor-pointer hover:bg-red-100 transition-colors"
								onClick={() => setDialogTemplates(true)}
							>
								<div className="flex items-center gap-2">
									<Clock className="w-[18px] h-[18px] text-red-500" />
									<div>
										<p className="text-xs text-red-600 font-medium">
											{shouldBlockForMissingLastDate() ? t('chat.input.businessBlock.noClientContact') : t('chat.input.businessBlock.windowExpired')}
										</p>
										<p className="text-xs text-red-500">
											{t('chat.input.businessBlock.clickToUseTemplates')}
										</p>
									</div>
								</div>
								<ArrowRight className="w-4 h-4 text-red-500" />

							</div>
						) : recording ? (
							// Barra de gravação de áudio (substitui o input enquanto grava)
							<RecordingBar
								loading={loading}
								onCancel={v2_handleCancelAudio}
								onSend={v2_stopRecording}
								cancelLabel={t('chat.audio.cancel')}
								sendLabel={t('chat.audio.send')}
								sendingLabel={t('chat.input.sending')}
							/>
						) : (
							// Input normal quando tempo não expirou
							<div className="relative flex-1 mt-2">
								<Textarea
									ref={textareaRef}
									disabled={loadingSendText}
									value={text}
									rows={2}
									onPaste={handleOnPaste}
									onKeyDown={handleKeyDown}
									onKeyUp={handleKeyUp}
									onChange={onChangeText}
									className={`pl-3 pr-9 text-sm font-normal bg-slate-50 w-full rounded-xl border-gray-200 focus-visible:ring-[#7C3AED]/20 focus-visible:border-[#7C3AED] transition-colors ${isExpanded ? 'min-h-[320px] max-h-[60vh]' : 'min-h-[60px] max-h-[200px]'} resize-none`}
									placeholder={loadingSendText ? t('chat.input.sending') : t('chat.input.placeholderGeneric')}
								/>
								<TooltipProvider>
									<Tooltip>
										<TooltipTrigger asChild>
											<button
												type="button"
												onClick={() => setIsExpanded(v => !v)}
												className="absolute top-2 right-2 p-1 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-200/70 transition-colors"
												aria-label={isExpanded ? t('chat.input.reduceField') : t('chat.input.expandField')}
											>
												{isExpanded ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
											</button>
										</TooltipTrigger>
										<TooltipContent side="top">
											{isExpanded ? t('chat.input.reduce') : t('chat.input.expand')}
										</TooltipContent>
									</Tooltip>
								</TooltipProvider>
							</div>
						)}



						{!recording && (
							text.length > 0 ? (
								<Button
									size="icon"
									onClick={sendMessage}
									className="h-10 w-10 ml-2 mt-2 rounded-full bg-[#7C3AED] hover:bg-[#6d28d9] text-white shadow-sm shadow-[#7C3AED]/25 active:scale-95 transition-all animate-in zoom-in-75 duration-200 flex-shrink-0"
								>
									<Send className="h-4 w-4" />
								</Button>
							) : (
								// Só mostra botão de gravação quando não há bloqueio
								!shouldBlockInput() && (
									<Button
										variant="ghost"
										size="icon"
										disabled={loading}
										onClick={v2_startRecording}
										className="h-10 w-10 ml-2 mt-2 rounded-full bg-violet-50 hover:bg-violet-100 text-[#7C3AED] active:scale-95 transition-all flex-shrink-0"
									>
										<Mic className="h-5 w-5" />
									</Button>
								)
							)
						)}

						{/* <input {...getInputProps()} /> */}
					</div>
				</div>
			</div>
		</Card>
	);
}

export default ChatBottomBar;
